import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
import type { SvgIconProps } from "@mui/material/SvgIcon";
import styled from "styled-components";

import {
  BsArrowClockwise,
  BsPersonCircle,
  BsHouseFill,
  BsPieChart,
  BsAppIndicator,
  BsListCheck,
  BsCalendarCheck,
  BsCart,
  BsCartPlus,
  BsPersonGear,
  BsPersonWorkspace,
  BsCommand,
  BsPeople,
  BsGear,
  BsPersonVcard,
  BsPersonPlus,
  BsCast,
  BsLink,
  BsKey,
  BsBoxes,
  BsChevronBarRight,
  BsChevronBarLeft,
  BsChevronLeft,
  BsChevronRight,
  BsChevronDown,
  BsChevronUp,
  BsXLg,
  BsArrowUp,
  BsArrowDown,
  BsFilePerson,
  BsFilter,
  BsPlusCircle,
  BsDashCircle,
  BsXCircleFill,
  BsCheckCircleFill,
  BsExclamationOctagon,
  BsExclamationTriangle,
  BsXCircle,
  BsCheckCircle,
  BsQuestionCircle,
  BsPauseCircle,
  BsArrowReturnLeft,
  BsUpload,
  BsTextareaT,
  BsPlus,
  BsArrowsFullscreen,
  BsExclamationCircle,
  BsPassport,
  BsArrowDownUp,
} from "react-icons/bs";

import {
  TbMessage,
  TbMessage2Plus,
  TbTemplate,
  TbClockShield,
  TbMessage2Search,
  TbTerminal2,
  TbCircleKey,
  TbClockEdit,
  TbClockSearch,
  TbAddressBook,
  TbClockExclamation,
  TbInfinity,
  TbCircleCheck,
  TbFileUpload,
  TbDatabase,
  TbTransfer,
  TbArrowsDiff,
  TbArrowNarrowRight,
  TbPasswordUser,
  TbLayersLinked,
  TbListCheck,
  TbUserHexagon,
  TbLayoutSidebarRightExpand,
  TbLayoutSidebarRightCollapse,
  TbColumns1,
  TbDownload,
  TbUpload,
  TbFileTypeCsv,
  TbFileSpreadsheet,
} from "react-icons/tb";

import {
  MdMoreVert,
  MdAddCircleOutline,
  MdOutlineGroupAdd,
  MdOutlineSaveAs,
  MdOutlineSave,
  MdSend,
  MdInfoOutline,
  MdPlayCircleOutline,
  MdPauseCircleOutline,
  MdFormatListBulletedAdd,
  MdOutlineCompareArrows,
  MdOutlineComment,
  MdOutlineReviews,
  MdOutlineEmail,
  MdOutlinePhone,
  MdOpenInNew,
  MdOutlineDownloadForOffline,
  MdCleaningServices,
  MdOutlineSensorOccupied,
  MdOutlineKeyboardArrowDown,
  MdOutlineKeyboardArrowRight,
  MdContentCopy,
  MdOutlineRateReview,
  MdHistory,
  MdOutlineCompare,
  MdPlayArrow,
  MdPause,
  MdOutlineArrowForward,
  MdOutlineMailLock,
  MdOutlineScreenLockPortrait,
  MdEdit,
  MdArrowDropDown,
  MdOutlineApproval,
  MdOutlineLoop,
  MdOutlineSearch,
  MdOutlineKeyboardArrowLeft,
  MdOutlineFolderZip,
} from "react-icons/md";

import {
  FiEdit,
  FiInfo,
  FiUnlock,
  FiTrash,
  FiMinimize2,
  FiLock,
} from "react-icons/fi";

import { IoMdApps } from "react-icons/io";
import { IoCheckmarkDoneSharp, IoDocumentTextOutline, IoRefreshCircleOutline } from "react-icons/io5";
import { GrPowerReset, GrPowerShutdown } from "react-icons/gr";
import {
  AiOutlineLoading3Quarters,
  AiOutlineMenuUnfold,
  AiOutlineMenuFold,
} from "react-icons/ai";
import { CgSandClock, CgFileDocument } from "react-icons/cg";
import { ImCogs } from "react-icons/im";
import {
  LuSquareActivity,
  LuColumns2,
  LuColumns3,
  LuColumns4,
  LuFileJson2,
  LuFileSearch2,
  LuFilePlus2,
  LuFiles,
  LuFilePen,
  LuGlobe,
  LuUndo2,
} from "react-icons/lu";
import { PiHeartbeat, PiGear, PiGlobeSimpleXBold } from "react-icons/pi";
import { RiPassPendingLine } from "react-icons/ri";
import {
  BiExpandHorizontal,
  BiExpandVertical,
  BiCollapseHorizontal,
  BiCollapseVertical,
} from "react-icons/bi";

// Layout icon
export const HomeIcon = styled(BsHouseFill)`
  height: 1rem;
  width: 1rem;
`;

export const UserIcon = styled(BsPersonCircle)`
  height: 1.5rem;
  width: 1.5rem;
`;

export const UnfoldMenuIcon = styled(AiOutlineMenuUnfold)`
  height: 1.5rem;
  width: 1.5rem;
`;

export const FoldMenuIcon = styled(AiOutlineMenuFold)`
  height: 1.5rem;
  width: 1.5rem;
`;

export const ServiceMenuIcon = styled(IoMdApps)`
  height: 1.5rem;
  width: 1.5rem;
`;

// Nav icon
export const DashboardIcon = styled(BsPieChart)`
  height: 1.5rem;
  width: 1.5rem;
`;

export const ApplicationIcon = styled(BsAppIndicator)`
  height: 1.5rem;
  width: 1.5rem;
`;

export const ProductIcon = styled(BsCart)`
  height: 1.5rem;
  width: 1.5rem;
  stroke-width: 0.2;
`;

export const ClientIcon = styled(BsFilePerson)`
  height: 1.5rem;
  width: 1.5rem;
`;

export const BindingIcon = styled(BsLink)`
  height: 1.5rem;
  width: 1.5rem;
  stroke-width: 0.2;
`;

export const DeviceIcon = styled(BsCast)`
  height: 1.5rem;
  width: 1.5rem;
`;

export const AuthHistoryIcon = styled(TbClockShield)`
  height: 1.5rem;
  width: 1.5rem;
`;

export const EKYCIcon = styled(BsPersonVcard)`
  height: 1.5rem;
  width: 1.5rem;
`;

export const MessagingIcon = styled(TbMessage)`
  height: 1.5rem;
  width: 1.5rem;
`;

export const NewMessageIcon = styled(TbMessage2Plus)`
  height: 1.5rem;
  width: 1.5rem;
`;

export const MessageHistoryIcon = styled(TbMessage2Search)`
  height: 1.5rem;
  width: 1.5rem;
`;

export const TemplateIcon = styled(TbTemplate)`
  height: 1.5rem;
  width: 1.5rem;
`;

export const ResourceIcon = styled(BsBoxes)`
  height: 1.5rem;
  width: 1.5rem;
`;

export const ScheduleTaskIcon = styled(BsCalendarCheck)`
  height: 1.5rem;
  width: 1.5rem;
`;

export const TaskIcon = styled(BsListCheck)`
  height: 1.5rem;
  width: 1.5rem;
`;

export const ExecutionHistoryIcon = styled(TbTerminal2)`
  height: 1.5rem;
  width: 1.5rem;
`;

export const AdminGearIcon = styled(BsPersonGear)`
  height: 1.5rem;
  width: 1.5rem;
`;

export const AdminIcon = styled(BsPersonWorkspace)`
  height: 1.5rem;
  width: 1.5rem;
`;

export const AdminGroupIcon = styled(BsPeople)`
  height: 1.5rem;
  width: 1.5rem;
`;

export const SystemIcon = styled(BsCommand)`
  height: 1.5rem;
  width: 1.5rem;
  stroke-width: 0.2;
`;

export const KeyIcon = styled(BsKey)`
  height: 1.5rem;
  width: 1.5rem;
  stroke-width: 0.2;
`;

export const ConfigIcon = styled(BsGear)`
  height: 1.5rem;
  width: 1.5rem;
  stroke-width: 0.2;
`;

export const InfoIcon = styled(MdInfoOutline)`
  height: 1.5rem;
  width: 1.5rem;
`;
// Component icon

export const LoadingIcon = styled(AiOutlineLoading3Quarters)`
  height: 1.2rem;
  width: 1.2rem;
  animation: spin 1s linear infinite;
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

export const NextIcon = styled(BsChevronRight)`
  height: 1rem;
  width: 1rem;
`;

export const PrevIcon = styled(BsChevronLeft)`
  height: 1rem;
  width: 1rem;
`;

export const FirstItemIcon = styled(BsChevronBarLeft)`
  height: 1rem;
  width: 1rem;
`;

export const LastItemIcon = styled(BsChevronBarRight)`
  height: 1rem;
  width: 1rem;
`;

export const SortAscIcon = styled(BsArrowUp)`
  height: 0.8rem;
  width: 1rem;
`;

export const SortDescIcon = styled(BsArrowDown)`
  height: 0.8rem;
  width: 1rem;
`;

export const SortIcon = styled(BsArrowDownUp)`
  height: 0.8rem;
  width: 1rem;
`;

export const TableCheckIcon = styled(BsCheckCircleFill)`
  height: 1.2rem;
  width: 1.2rem;
  margin-top: 0.3rem;
  color: #4584c5;
  border-radius: 0.625rem;
  background-color: #fff;
`;

export const TableCrossIcon = styled(BsXCircleFill)`
  height: 1.2rem;
  width: 1.2rem;
  margin-top: 0.3rem;
  color: #919eab;
  border-radius: 0.625rem;
  background-color: #fff;
`;

export const SwitchCheckIcon = styled(BsCheckCircleFill)`
  height: 1.25rem;
  width: 1.25rem;
  color: #4584c5;
  border-radius: 0.625rem;
  background-color: #fff;
`;

export const SwitchCrossIcon = styled(BsXCircleFill)`
  height: 1.25rem;
  width: 1.25rem;
  color: #919eab;
  border-radius: 0.625rem;
  background-color: #fff;
`;

export const TableDetailIcon = styled(MdMoreVert)`
  height: 1.25rem;
  width: 1.25rem;
`;

export const FilterIcon = styled(BsFilter)`
  height: 1.5rem;
  width: 1.5rem;
  stroke-width: 0.5;
`;

export const AddItemIcon = styled(MdAddCircleOutline)`
  height: 1.5rem;
  width: 1.5rem;
`;

export const CloseIcon = styled(BsXLg)`
  height: 1.25rem;
  width: 1.25rem;
  stroke-width: 1;
`;

export const MinimizeIcon = styled(FiMinimize2)`
  height: 1.25rem;
  width: 1.25rem;
  stroke-width: 2.5;
`;

export const DeleteIcon = styled(FiTrash)`
  height: 1.2rem;
  width: 1.2rem;
`;

export const DetailIcon = styled(FiInfo)`
  height: 1.2rem;
  width: 1.2rem;
`;

export const EditIcon = styled(FiEdit)`
  height: 1.2rem;
  width: 1.2rem;
`;

export const UnlockIcon = styled(FiUnlock)`
  height: 1.2rem;
  width: 1.2rem;
`;

export const LockIcon = styled(FiLock)`
  height: 1.2rem;
  width: 1.2rem;
`;

export const EnableIcon = styled(BsCheckCircleFill)`
  height: 1.2rem;
  width: 1.2rem;
  color: #4584c5;
  border-radius: 0.625rem;
  background-color: #fff;
`;

export const DisableIcon = styled(BsXCircleFill)`
  height: 1.2rem;
  width: 1.2rem;
  color: #919eab;
  border-radius: 0.625rem;
  background-color: #fff;
`;

export const ExpirePasswordIcon = styled(BsExclamationOctagon)`
  height: 1.2rem;
  width: 1.2rem;
  stroke-width: 0.4;
`;

export const AddAdminIcon = styled(BsPersonPlus)`
  height: 1.4rem;
  width: 1.4rem;
  stroke-width: 0.4;
`;

export const AddAdminGroupIcon = styled(MdOutlineGroupAdd)`
  height: 1.5rem;
  width: 1.5rem;
`;

export const EkycCheckIcon = styled(BsCheckCircle)`
  height: 1.2rem;
  width: 1.2rem;
  color: #00a76f;
  border-radius: 0.625rem;
`;

export const EkycCrossIcon = styled(BsXCircle)`
  height: 1.2rem;
  width: 1.2rem;
  color: #ff5630;
  border-radius: 0.625rem;
`;

export const EkycUnknownIcon = styled(BsQuestionCircle)`
  height: 1.2rem;
  width: 1.2rem;
  color: #919eab;
  border-radius: 0.625rem;
`;

export const EkycPendingIcon = styled(BsPauseCircle)`
  height: 1.2rem;
  width: 1.2rem;
  color: #ffab00;
  border-radius: 0.625rem;
`;

export const EkycInfoIcon = styled(BsExclamationCircle)`
  height: 1.2rem;
  width: 1.2rem;
  border-radius: 0.625rem;
`;

export const EkycMatchedIcon = styled(IoCheckmarkDoneSharp)`
  height: 1.2rem;
  width: 1.2rem;
  color: #00a76f;
`;

export const EkycDiffIcon = styled(TbArrowsDiff)`
  height: 1.2rem;
  width: 1.2rem;
  color: #ff5630;
`;

export const EkycWhiteListIcon = styled(BsPassport)`
  color: #b76e00;
  height: 1rem;
  width: 1rem;
  stroke-width: 0.25;
`;

export const ReturnIcon = styled(BsArrowReturnLeft)`
  height: 1.2rem;
  width: 1.2rem;
  stroke-width: 0.4;
`;

export const RefreshIcon = styled(BsArrowClockwise)`
  height: 1.2rem;
  width: 1.2rem;
`;

export const ExpandMoreIcon = styled(BsChevronDown)`
  height: 1rem;
  width: 1rem;
  stroke-width: 1;
`;
export const CollapseIcon = styled(BsChevronUp)`
  height: 1rem;
  width: 1rem;
  stroke-width: 1;
`;
export const FileUploadIcon = styled(BsUpload)`
  height: 1.2rem;
  width: 1.2rem;
`;
export const TextInputIcon = styled(BsTextareaT)`
  height: 1.2rem;
  width: 1.2rem;
`;
export const RefreshKeyIcon = styled(IoRefreshCircleOutline)`
  height: 1.5rem;
  width: 1.5rem;
`;
export const AccessKeyIcon = styled(TbCircleKey)`
  height: 1.5rem;
  width: 1.5rem;
  stroke-width: 1.5;
`;
export const HistoricPasswordCountIcon = styled(TbClockEdit)`
  height: 1.3rem;
  width: 1.3rem;
  stroke-width: 1.5;
`;
export const PlusIcon = styled(BsPlusCircle)`
  height: 1rem;
  width: 1rem;
`;
export const MinusIcon = styled(BsDashCircle)`
  height: 1rem;
  width: 1rem;
`;
export const InnerAddIcon = styled(BsPlus)`
  height: 1.2rem;
  width: 1.2rem;
`;
export const SaveEditedIcon = styled(MdOutlineSaveAs)`
  height: 1.2rem;
  width: 1.2rem;
`;
export const SaveSchemaIcon = styled(MdOutlineSave)`
  height: 1.5rem;
  width: 1.5rem;
`;

export const LargePreviewIcon = styled(LuFileSearch2)`
  height: 1.5rem;
  width: 1.5rem;
`;

export const LargeEditIcon = styled(MdEdit)`
  height: 1.5rem;
  width: 1.5rem;
`;

export const AddTemplateIcon = styled(() => (
  <SvgIcon>
    <svg
      stroke="currentColor"
      fill="none"
      strokeWidth="2"
      viewBox="0 0 24 24"
      strokeLinecap="round"
      strokeLinejoin="round"
      height="200px"
      width="200px"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M4 4 m0 1a1 1 0 0 1 1 -1 h11 a1 1 0 0 1 1 1 v1.5 a1 1 0 0 1 -1 1 h-11 a1 1 0 0 1 -1 -1z"></path>
      <path d="M4 11 m0 1a1 1 0 0 1 1 -1h3 a1 1 0 0 1 1 1v5a1 1 0 0 1 -1 1h-3a1 1 0 0 1 -1 -1z"></path>
      <path d="M12 11l5 0"></path>
      <path d="M12 14.5l3 0"></path>
      <path d="M12 18l0.5 0"></path>
      <path d="M15.5 18h5"></path>
      <path d="M18 15.5 v5"></path>
    </svg>
  </SvgIcon>
))`
  height: 1.2rem;
  width: 1.2rem;
`;

export const ResetIcon = styled(GrPowerReset)`
  height: 1.2rem;
  width: 1.2rem;
`;

export const SendIcon = styled(MdSend)`
  height: 1.2rem;
  width: 1.2rem;
`;

export const PlayIcon = styled(MdPlayCircleOutline)`
  height: 1.2rem;
  width: 1.2rem;
`;

export const PauseIcon = styled(MdPauseCircleOutline)`
  height: 1.2rem;
  width: 1.2rem;
`;

export const AddTaskIcon = styled(MdFormatListBulletedAdd)`
  height: 1.2rem;
  width: 1.2rem;
`;

export const ApplicationHistoryIcon = styled(TbClockSearch)`
  height: 1.5rem;
  width: 1.5rem;
`;

export const ApplicationCompareIcon = styled(MdOutlineCompareArrows)`
  height: 1.2rem;
  width: 1.2rem;
`;

export const EKYCHistoryIcon = styled(() => (
  <SvgIcon>
    <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      viewBox="0 0 256 256"
      height="200px"
      width="200px"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M181.36,114.73l-48,24A12,12,0,0,1,116,128V72a12,12,0,0,1,24,0v36.58l30.63-15.31a12,12,0,1,1,10.73,21.46Zm45.72,120.86a12,12,0,0,1-14.68-8.51C210,218.2,201.65,212,192,212s-18,6.2-20.4,15.08A12,12,0,0,1,160,236a11.77,11.77,0,0,1-3.09-.41,12,12,0,0,1-8.52-14.68,43.76,43.76,0,0,1,15.08-23,36,36,0,1,1,57,0,43.7,43.7,0,0,1,15.08,23A12,12,0,0,1,227.08,235.59ZM180,176a12,12,0,1,0,12-12A12,12,0,0,0,180,176Zm-62.52,35.35a84,84,0,1,1,93.87-93.87,12,12,0,1,0,23.81-3A108,108,0,1,0,114.51,235.16a11,11,0,0,0,1.5.1,12,12,0,0,0,1.47-23.91Z"></path>
    </svg>
  </SvgIcon>
))`
  height: 1.4rem;
  width: 1.4rem;
`;

export const EKYCDetailIcon = styled(BsPersonVcard)`
  height: 1.2rem;
  width: 1.2rem;
`;

export const AddrBookIcon = styled(TbAddressBook)`
  height: 1.2rem;
  width: 1.2rem;
`;

export const CommentIcon = styled(MdOutlineComment)`
  height: 1.2rem;
  width: 1.2rem;
`;

export const ReviewIcon = styled(MdOutlineReviews)`
  height: 1.2rem;
  width: 1.2rem;
`;

export const PhoneIcon = styled(MdOutlinePhone)`
  height: 1.2rem;
  width: 1.2rem;
`;

export const EmailIcon = styled(MdOutlineEmail)`
  height: 1.2rem;
  width: 1.2rem;
`;

export const VerifiedIcon = styled(BsCheckCircle)`
  height: 1rem;
  width: 1rem;
  stroke-width: 1;
  border-radius: 0.625rem;
  color: #00a76f;
`;

export const BrokenImageIcon = styled(() => (
  <SvgIcon>
    <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      viewBox="0 0 256 256"
      height="200px"
      width="200px"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M216,42H40A14,14,0,0,0,26,56V200a14,14,0,0,0,14,14h64a6,6,0,0,0,5.69-4.1l15.12-45.36,37.42-15a6,6,0,0,0,3.34-3.34l15-37.42L225.9,93.69A6,6,0,0,0,230,88V56A14,14,0,0,0,216,42ZM117.77,154.43a6,6,0,0,0-3.46,3.67L99.68,202H40a2,2,0,0,1-2-2V171.17l52.58-52.58a2,2,0,0,1,2.83,0L126,151.15ZM218,83.68,174.1,98.31a6,6,0,0,0-3.67,3.46l-15.05,37.61L138.1,146.3l-36.2-36.2a14,14,0,0,0-19.8,0L38,154.2V56a2,2,0,0,1,2-2H216a2,2,0,0,1,2,2Zm9.51,33.18a6,6,0,0,0-5.41-.82L198.3,124a6,6,0,0,0-3.67,3.47L180,164l-36.56,14.63A6,6,0,0,0,140,182.3L132,206.1a6,6,0,0,0,5.69,7.9H216a14,14,0,0,0,14-14V121.73A6,6,0,0,0,227.51,116.86ZM218,200a2,2,0,0,1-2,2H146.06l4.42-13.26,36.37-14.55a6,6,0,0,0,3.34-3.34l14.55-36.37L218,130.06Z"></path>
    </svg>
  </SvgIcon>
))`
  height: 1rem;
  width: 1rem;
`;

export const IsEffectiveIcon = styled(TbCircleCheck)`
  height: 1.2rem;
  width: 1.2rem;
  color: #00a76f;
`;

export const EffectiveAfterIcon = styled(CgSandClock)`
  height: 1.2rem;
  width: 1.2rem;
  color: #ffab00;
`;

export const ExpiredIcon = styled(TbClockExclamation)`
  height: 1.2rem;
  width: 1.2rem;
  color: #ff5630;
`;

export const AddProductIcon = styled(BsCartPlus)`
  height: 1.2rem;
  width: 1.2rem;
`;

export const FullScreenIcon = styled(BsArrowsFullscreen)`
  height: 1rem;
  width: 1rem;
`;

export const OpenInNewIcon = styled(MdOpenInNew)`
  height: 1.2rem;
  width: 1.2rem;
`;

export const InfinityIcon = styled(TbInfinity)`
  height: 1.2rem;
  width: 1.2rem;
  color: #00a76f;
`;

export const DownloadIcon = styled(MdOutlineDownloadForOffline)`
  height: 1.4rem;
  width: 1.4rem;
`;

export const ResourceUploadIcon = styled(TbFileUpload)`
  height: 1.4rem;
  width: 1.4rem;
`;

export const AWSBucketIcon = styled((props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg viewBox="0 0 398.096 330.347" xmlns="http://www.w3.org/2000/svg">
      <path d="M 86.716 85.915 C 86.431 94.942 90.941 98.938 91.052 101.476 C 90.945 102.526 90.336 103.456 89.419 103.976 L 84.318 107.546 C 83.657 108.008 82.878 108.274 82.075 108.312 C 81.903 108.303 78.81 109.039 73.911 98.106 C 67.857 105.664 58.646 109.997 48.962 109.841 C 42.475 110.196 24.892 106.159 25.797 87.44 C 25.163 72.187 39.37 62.709 54.062 63.511 C 56.891 63.519 62.67 63.658 72.789 66.009 L 72.789 59.785 C 73.861 49.24 66.931 41.059 54.931 42.286 C 53.976 42.291 47.201 42.087 36.663 46.316 C 33.731 47.662 33.356 47.44 32.381 47.44 C 29.428 47.44 30.643 38.879 31.208 37.796 C 33.285 35.245 45.499 30.482 57.486 30.55 C 65.502 29.842 73.473 32.315 79.678 37.437 C 84.776 43.139 87.32 50.678 86.721 58.303 L 86.716 85.915 Z M 52.278 98.823 C 65.2 98.635 70.672 90.865 71.92 86.68 C 72.899 82.676 72.737 80.14 72.737 75.761 C 68.883 74.837 63.337 73.828 56.972 73.82 C 50.934 73.366 39.908 76.064 40.338 86.676 C 39.844 93.367 44.77 99.189 52.278 98.823 Z M 120.391 108.008 C 117.258 108.294 115.8 106.071 115.336 103.876 L 95.493 38.261 C 95.104 37.154 94.85 36.01 94.726 34.842 C 94.574 33.84 95.263 32.904 96.265 32.751 C 96.36 32.735 95.416 32.751 105.132 32.751 C 108.631 32.399 109.77 35.153 110.132 36.882 L 124.366 93.004 L 137.582 36.882 C 137.792 35.599 138.753 32.471 142.683 32.802 L 149.522 32.802 C 150.387 32.729 153.949 32.602 154.575 36.933 L 167.893 93.774 L 182.585 36.933 C 182.777 36.066 183.67 32.403 187.639 32.802 L 195.497 32.802 C 195.835 32.751 197.947 32.479 197.589 36.221 C 197.417 36.958 198.947 31.973 176.568 103.928 C 176.11 106.124 174.648 108.347 171.515 108.06 L 164.067 108.06 C 159.707 108.519 159.082 104.21 159.014 103.776 L 145.799 49.128 L 132.736 103.721 C 132.672 104.155 132.047 108.461 127.682 108.003 L 120.391 108.003 L 120.391 108.008 Z M 229.375 110.251 C 227.031 110.255 215.857 110.132 206.516 105.353 C 204.613 104.548 203.384 102.674 203.403 100.608 L 203.403 96.324 C 203.403 92.957 205.875 93.574 206.922 93.977 C 210.924 95.595 213.489 96.822 218.403 97.803 C 233.009 100.802 239.433 96.885 241.006 96.017 C 246.247 92.906 246.661 85.783 243.1 82.089 C 238.923 78.586 236.931 78.454 221.927 73.721 C 220.076 73.207 204.512 68.297 204.475 52.855 C 204.232 41.6 214.457 30.466 232.179 30.559 C 237.229 30.554 250.683 32.205 254.325 36.783 C 254.863 37.616 255.129 38.596 255.09 39.588 L 255.09 43.617 C 255.09 45.386 254.444 46.271 253.149 46.271 C 250.077 45.929 244.625 41.82 233.558 41.988 C 230.812 41.844 217.661 42.351 218.252 51.938 C 218.079 59.494 228.856 62.327 230.087 62.653 C 244.616 67.026 249.474 67.752 255.241 74.442 C 262.071 83.309 258.39 93.69 256.974 96.535 C 249.371 111.475 229.709 110.259 229.375 110.251 Z M 245.394 152.039 C 217.487 172.65 176.973 183.62 142.385 183.62 C 95.711 183.929 50.61 166.766 15.949 135.509 C 13.347 133.162 15.643 129.946 18.808 131.735 C 57.256 153.73 100.79 165.286 145.087 165.258 C 178.165 165.08 210.882 158.369 241.361 145.511 C 246.055 143.519 250.037 148.619 245.394 152.039 Z M 257.026 138.772 C 253.455 134.181 233.403 136.629 224.425 137.7 C 221.719 138.008 221.261 135.66 223.711 133.927 C 239.679 122.701 265.906 125.917 268.918 129.691 C 271.927 133.464 268.101 159.742 253.153 172.295 C 250.857 174.236 248.662 173.212 249.682 170.661 C 253.045 162.194 260.596 143.368 257.026 138.772 Z" />
      <path
        d="M 367.656 251.505 L 368.378 246.134 C 374.128 249.64 375.904 251.664 376.422 252.52 C 374.895 252.98 371.814 252.573 367.656 251.505 Z M 310.61 232 C 310.61 231.828 310.745 231.687 310.918 231.687 C 310.964 231.687 311.001 231.723 311.047 231.746 L 310.806 232.219 C 310.701 232.189 310.61 232.123 310.61 232 Z M 354.797 298.711 C 354.781 298.855 354.766 298.997 354.766 299.139 C 354.766 299.637 353.547 301.538 348.12 303.684 C 345.7 304.637 342.836 305.495 339.618 306.24 C 331.319 308.158 321.12 309.217 310.912 309.217 C 283.625 309.217 267.057 302.225 267.057 299.139 C 267.057 298.997 267.049 298.855 267.027 298.711 L 254.661 206.759 C 255.452 207.225 256.308 207.668 257.203 208.098 C 257.458 208.225 257.736 208.338 257.998 208.459 C 258.774 208.821 259.578 209.167 260.413 209.497 C 260.773 209.639 261.142 209.782 261.51 209.925 C 262.397 210.256 263.321 210.58 264.269 210.889 C 264.546 210.987 264.817 211.084 265.102 211.165 C 266.322 211.55 267.592 211.918 268.892 212.265 C 269.26 212.362 269.634 212.453 270.004 212.543 C 271.011 212.8 272.034 213.046 273.085 213.28 C 273.536 213.385 273.986 213.482 274.447 213.574 C 275.619 213.822 276.821 214.062 278.046 214.289 C 278.311 214.333 278.567 214.386 278.829 214.431 C 280.31 214.695 281.819 214.927 283.354 215.152 C 283.783 215.221 284.226 215.274 284.662 215.334 C 285.82 215.492 286.999 215.642 288.187 215.778 C 288.669 215.83 289.157 215.89 289.645 215.943 C 291.075 216.1 292.517 216.236 293.976 216.365 C 294.14 216.371 294.314 216.395 294.495 216.409 C 296.118 216.539 297.75 216.642 299.388 216.739 C 299.854 216.769 300.326 216.785 300.793 216.807 C 302.034 216.877 303.267 216.921 304.507 216.965 C 304.995 216.98 305.476 216.996 305.958 217.012 C 307.611 217.042 309.266 217.071 310.912 217.071 C 312.556 217.071 314.211 217.042 315.857 217.012 C 316.345 216.996 316.835 216.98 317.316 216.965 C 318.556 216.921 319.789 216.877 321.022 216.807 C 321.494 216.785 321.962 216.769 322.435 216.739 C 324.074 216.642 325.704 216.539 327.329 216.409 C 327.509 216.395 327.683 216.371 327.863 216.365 C 329.313 216.236 330.749 216.1 332.178 215.943 C 332.673 215.89 333.155 215.83 333.649 215.778 C 334.831 215.642 336.003 215.492 337.154 215.334 C 337.596 215.274 338.04 215.221 338.476 215.152 C 340.011 214.927 341.52 214.695 342.994 214.431 C 343.263 214.386 343.528 214.333 343.791 214.28 C 345.009 214.062 346.205 213.822 347.383 213.574 C 347.842 213.482 348.294 213.385 348.745 213.28 C 349.796 213.046 350.819 212.8 351.827 212.543 C 352.196 212.453 352.57 212.362 352.938 212.265 C 354.246 211.918 355.508 211.55 356.736 211.165 C 357.013 211.084 357.276 210.987 357.546 210.895 C 358.509 210.58 359.434 210.256 360.327 209.918 C 360.688 209.782 361.049 209.648 361.41 209.506 C 362.252 209.167 363.065 208.821 363.845 208.459 C 364.102 208.338 364.372 208.225 364.627 208.106 C 365.523 207.668 366.378 207.225 367.175 206.759 L 361.395 249.67 C 349.677 245.909 333.213 239.08 317.63 231.662 C 317.46 228.098 314.527 225.239 310.918 225.239 C 307.19 225.239 304.16 228.27 304.16 232 C 304.16 235.725 307.19 238.757 310.918 238.757 C 312.377 238.757 313.73 238.275 314.835 237.476 C 328.794 244.179 346.616 252.092 360.531 256.108 L 354.797 298.711 Z M 310.912 180.041 C 344.49 180.041 368.147 190.454 368.582 196.237 L 368.5 196.905 C 368.445 197.109 368.318 197.313 368.214 197.515 C 368.123 197.688 368.063 197.847 367.942 198.02 C 367.799 198.215 367.591 198.418 367.41 198.62 C 367.243 198.8 367.1 198.982 366.906 199.162 C 366.688 199.358 366.408 199.561 366.147 199.758 C 365.905 199.945 365.686 200.132 365.418 200.321 C 365.122 200.516 364.77 200.711 364.441 200.915 C 364.124 201.104 363.832 201.298 363.47 201.487 C 363.117 201.683 362.703 201.869 362.313 202.058 C 361.913 202.262 361.539 202.449 361.103 202.644 C 360.681 202.833 360.208 203.015 359.764 203.201 C 359.281 203.389 358.825 203.594 358.314 203.78 C 357.832 203.962 357.3 204.134 356.794 204.314 C 356.238 204.503 355.713 204.698 355.126 204.879 C 354.586 205.059 353.983 205.217 353.405 205.391 C 352.796 205.571 352.202 205.751 351.556 205.925 C 350.94 206.098 350.271 206.248 349.632 206.412 C 348.963 206.58 348.316 206.744 347.618 206.909 C 346.924 207.067 346.174 207.21 345.444 207.359 C 344.745 207.503 344.06 207.662 343.324 207.795 C 342.551 207.948 341.723 208.082 340.919 208.218 C 340.174 208.347 339.46 208.482 338.687 208.603 C 337.852 208.731 336.957 208.843 336.094 208.963 C 335.303 209.07 334.538 209.189 333.724 209.287 C 332.778 209.408 331.785 209.497 330.808 209.603 C 330.019 209.685 329.26 209.776 328.457 209.85 C 327.372 209.948 326.239 210.023 325.126 210.099 C 324.375 210.158 323.645 210.218 322.877 210.273 C 321.659 210.34 320.382 210.386 319.112 210.445 C 318.413 210.467 317.736 210.512 317.03 210.535 C 315.03 210.586 312.994 210.627 310.912 210.627 C 308.828 210.627 306.791 210.586 304.794 210.535 C 304.078 210.512 303.395 210.467 302.681 210.437 C 301.425 210.386 300.162 210.34 298.945 210.273 C 298.133 210.218 297.365 210.15 296.576 210.091 C 295.509 210.016 294.412 209.948 293.367 209.85 C 292.564 209.776 291.803 209.677 291.014 209.603 C 290.036 209.497 289.036 209.408 288.095 209.287 C 287.292 209.189 286.527 209.076 285.745 208.963 C 284.874 208.843 283.978 208.731 283.135 208.603 C 282.341 208.482 281.588 208.338 280.821 208.204 C 280.046 208.068 279.249 207.94 278.506 207.795 C 277.754 207.662 277.063 207.503 276.341 207.353 C 275.628 207.202 274.89 207.061 274.205 206.902 C 273.506 206.744 272.868 206.58 272.198 206.412 C 271.552 206.248 270.883 206.098 270.267 205.925 C 269.613 205.751 269.019 205.562 268.395 205.383 C 267.831 205.217 267.238 205.053 266.704 204.879 C 266.103 204.691 265.569 204.495 265.013 204.3 C 264.516 204.134 263.99 203.962 263.525 203.78 C 262.999 203.594 262.547 203.389 262.058 203.194 C 261.616 203.015 261.142 202.825 260.727 202.644 C 260.3 202.449 259.922 202.262 259.518 202.058 C 259.135 201.869 258.713 201.683 258.36 201.487 C 258.007 201.29 257.706 201.104 257.382 200.906 C 257.06 200.711 256.708 200.516 256.421 200.321 C 256.134 200.126 255.918 199.937 255.677 199.747 C 255.422 199.553 255.142 199.351 254.932 199.162 C 254.73 198.974 254.587 198.794 254.413 198.613 C 254.233 198.411 254.031 198.215 253.896 198.02 C 253.767 197.847 253.707 197.673 253.616 197.499 C 253.512 197.305 253.391 197.1 253.33 196.905 L 253.241 196.237 C 253.691 190.454 277.34 180.041 310.912 180.041 Z M 382.97 251.82 C 382.285 248.114 378.008 244.179 369.311 239.207 L 374.843 198.088 L 374.843 198.072 L 375.008 196.816 C 375.024 196.673 375.039 196.537 375.039 196.402 C 375.039 182.961 341.242 173.596 310.912 173.596 C 280.58 173.596 246.791 182.961 246.791 196.402 C 246.791 196.537 246.799 196.68 246.822 196.823 L 246.987 198.079 L 246.987 198.088 L 260.614 299.387 C 261.037 311.241 291.6 315.665 310.912 315.665 C 321.593 315.665 332.306 314.552 341.07 312.521 C 344.594 311.707 347.758 310.753 350.481 309.677 C 357.463 306.924 361.073 303.457 361.216 299.387 L 366.822 257.695 C 369.889 258.35 372.679 258.748 374.993 258.748 C 378.12 258.748 380.45 258.088 381.714 256.574 C 382.85 255.235 383.292 253.544 382.97 251.82 Z"
        style={{ stroke: "rgb(8, 8, 8)", strokeWidth: "4px" }}
      />
    </svg>
  </SvgIcon>
))`
  height: 2rem;
  width: 2rem;
`;

export const DatabaseIcon = styled(TbDatabase)`
  height: 1.5rem;
  width: 1.5rem;
  stroke-width: 1.5;
`;

export const ResourceAddIcon = styled((props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg
      viewBox="0 0 16 16"
      stroke="currentColor"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M 6.585 1.734 C 6.693 1.671 6.826 1.671 6.935 1.734 L 9.574 3.241 C 9.683 3.304 9.75 3.421 9.75 3.547 L 9.75 6.358 L 12.212 7.765 C 12.323 7.826 12.298 8.139 12.243 8.321 L 9.704 9.779 C 9.704 9.905 9.706 12.873 9.706 12.873 C 9.597 12.935 9.333 12.935 9.224 12.873 L 6.76 11.492 L 4.296 12.9 C 4.188 12.962 4.054 12.962 3.946 12.9 L 1.307 11.391 C 1.198 11.33 1.13 11.213 1.13 11.087 L 1.13 8.071 C 1.13 7.945 1.198 7.827 1.307 7.764 L 3.769 6.358 L 3.769 3.547 C 3.769 3.421 3.837 3.304 3.946 3.241 L 6.585 1.734 Z M 4.121 6.968 L 2.19 8.071 L 4.121 9.173 L 6.05 8.071 L 4.121 6.968 Z M 6.408 8.677 L 4.472 9.783 L 4.472 11.988 L 6.408 10.883 L 6.408 8.677 Z M 7.111 10.883 L 9.047 11.988 L 9.047 9.783 L 7.111 8.677 L 7.111 10.883 Z M 7.469 8.071 L 9.399 9.173 L 11.328 8.071 L 9.399 6.968 L 7.469 8.071 Z M 9.047 6.358 L 9.047 4.152 L 7.111 5.259 L 7.111 7.464 L 9.047 6.358 Z M 6.408 7.464 L 6.408 5.259 L 4.472 4.152 L 4.472 6.358 L 6.408 7.464 Z M 4.83 3.547 L 6.76 4.65 L 8.689 3.547 L 6.76 2.444 L 4.83 3.547 Z M 3.769 11.988 L 3.769 9.783 L 1.833 8.677 L 1.833 10.883 L 3.769 11.988 Z"
        style={{ strokeWidth: "0px" }}
      />
      <path
        d="M 12.971 10.18 H 12.972 V 11.872 H 14.663 V 11.873 H 12.972 V 13.564 H 12.971 V 11.873 H 11.279 V 11.872 H 12.971 Z"
        style={{ strokeLinecap: "round", strokeLinejoin: "round" }}
      />
    </svg>
  </SvgIcon>
))`
  height: 1.5rem;
  width: 1.5rem;
`;

export const TestConfigIcon = styled(ImCogs)`
  height: 1.2rem;
  width: 1.2rem;
`;

export const HeartBeatIcon = styled(LuSquareActivity)`
  height: 1.5rem;
  width: 1.5rem;
`;

export const ServiceHealthWarningIcon = styled(BsExclamationTriangle)`
  height: 1.4rem;
  width: 1.4rem;
  color: #ff5630;
`;

export const ServiceHealthUnknownIcon = styled(BsQuestionCircle)`
  height: 1.4rem;
  width: 1.4rem;
  color: #ffab00;
`;

export const ServiceHealthUpIcon = styled(PiHeartbeat)`
  height: 1.6rem;
  width: 1.6rem;
  color: #00a76f;
`;

export const ServiceHealthResultIcon = styled(CgFileDocument)`
  height: 1.4rem;
  width: 1.4rem;
`;

export const PurgeIcon = styled(MdCleaningServices)`
  height: 1.2rem;
  width: 1.2rem;
`;

export const ServiceShutDownIcon = styled(GrPowerShutdown)`
  height: 1.2rem;
  width: 1.2rem;
`;

export const BoldResetIcon = styled((props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="2.8"
      viewBox="0 0 24 24"
      height="200px"
      width="200px"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="none"
        d="M20,8 C18.5974037,5.04031171 15.536972,3 12,3 C7.02943725,3 3,7.02943725 3,12 C3,16.9705627 7.02943725,21 12,21 L12,21 C16.9705627,21 21,16.9705627 21,12 M21,3 L21,9 L15,9"
      ></path>
    </svg>
  </SvgIcon>
))`
  height: 1.2rem;
  width: 1.2rem;
`;

export const TransferIcon = styled(TbTransfer)`
  height: 1.2rem;
  width: 1.2rem;
`;

export const ConvertToIcon = styled(TbArrowNarrowRight)`
  height: 1rem;
  width: 1rem;
`;

export const EkycTransactionIcon = styled(IoDocumentTextOutline)`
  height: 1.2rem;
  width: 1.2rem;
`;

export const EkycZolozFaceOcclusionIcon = styled(MdOutlineSensorOccupied)`
  height: 1.2rem;
  width: 1.2rem;
`;

export const EkycZolozExpandedIcon = styled(MdOutlineKeyboardArrowDown)`
  height: 1rem;
  width: 1rem;
`;

export const EkycZolozCollapsedIcon = styled(MdOutlineKeyboardArrowRight)`
  height: 1rem;
  width: 1rem;
`;

export const CopyIcon = styled(MdContentCopy)`
  height: 1rem;
  width: 1rem;
`;

export const EkycReviewStatusIcon = styled(MdOutlineRateReview)`
  height: 1rem;
  width: 1rem;
`;

export const EkycServiceIcon = styled((props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg
      viewBox="0 0 1024 1024"
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <mask id="mask-0">
          <path
            style={{
              fill: "rgb(255, 255, 255)",
              // stroke: "rgb(0, 0, 0)",
              // strokeWidth: "1px",
            }}
            d="M 1025.334 562.858 C 906.504 562.858 793.862 555.867 675.03 562.858 C 671.645 563.057 629.251 564.593 627.552 567.992 C 627.123 568.847 560.499 543.607 558.26 623.174 C 558.26 681.099 554.415 769.52 559.544 827.227 C 563.65 873.427 655.782 891.34 655.782 937.594 C 626.858 937.592 597.522 941.362 568.527 938.877 C 502.91 933.252 437.427 921.017 372.201 914.494 C 274.93 904.766 171.31 935.11 83.487 882.411 C 67.108 872.581 53.378 851.012 39.861 837.493 C 22.074 819.705 8.794 801.019 -2.484 778.459 C -15.874 751.676 -34.725 719.738 -39.696 689.909 C -47.763 641.503 -30.567 594.824 -25.581 547.458 C -20.626 500.374 -20.449 449.747 -20.449 402.441 C -20.449 335.371 -47.24 270.526 -53.811 204.805 C -58.68 156.11 -57.591 115.881 -15.315 84.171 C 51.079 34.369 136.1 11.534 216.938 0.754 C 258.016 -4.725 309.938 -17.86 351.671 -9.512 C 371.54 -5.538 390.919 -0.635 410.696 3.321 C 420.091 5.199 426.137 11.9 433.794 16.154 C 462.175 31.924 499.272 31.64 528.748 43.104 C 543.187 48.72 561.623 59.788 577.509 59.788 C 587.927 61.071 603.834 61.113 608.304 70.055 C 609.34 72.124 641.653 70.055 641.667 70.055 C 675.193 70.055 707.712 74.775 740.471 77.755 C 788.233 82.097 837.409 96.071 880.336 117.538 C 892.952 123.848 902.79 134.809 914.982 141.922 C 946.484 160.3 977.594 181.284 997.105 212.506 C 1003.989 223.52 1007.843 242.189 1011.22 254.855 C 1027.588 316.241 1030.468 372.218 1030.468 435.807 C 1030.468 477.989 1027.968 520.72 1025.334 562.858 C 1024.445 577.098 1035.875 552.315 1025.334 562.858 Z"
          />
        </mask>
      </defs>
      <path
        d="M 822.954 160 L 92.11 160 C 76.561 160 64 172.25 64 187.414 L 64 735.677 C 64 750.84 76.561 763.091 92.11 763.091 L 822.954 763.091 C 838.503 763.091 851.064 750.84 851.064 735.677 L 851.064 187.414 C 851.064 172.25 838.503 160 822.954 160 Z M 787.817 701.411 L 647.833 701.411 L 127.246 701.411 L 127.246 221.679 L 787.817 221.679 L 787.817 701.411 Z M 543.881 430.706 L 652.277 430.706 C 653.42 430.706 654.298 427.621 654.298 423.853 L 654.298 382.733 C 654.298 378.964 653.42 375.878 652.277 375.878 L 543.881 375.878 C 542.739 375.878 541.86 378.964 541.86 382.733 L 541.86 423.853 C 541.86 427.621 542.739 430.706 543.881 430.706 Z M 548.097 554.066 L 711.22 554.066 C 714.645 554.066 717.457 550.981 717.457 547.211 L 717.457 506.092 C 717.457 502.322 714.645 499.238 711.22 499.238 L 548.097 499.238 C 544.671 499.238 541.86 502.322 541.86 506.092 L 541.86 547.211 C 541.86 550.981 544.671 554.066 548.097 554.066 Z M 204.547 599.468 L 243.11 599.468 C 246.799 599.468 249.787 596.641 250.05 593.043 C 253.387 549.781 290.457 515.516 335.431 515.516 C 380.407 515.516 417.477 549.781 420.813 593.043 C 421.077 596.641 424.064 599.468 427.753 599.468 L 466.316 599.468 C 470.338 599.473 473.546 596.19 473.344 592.273 C 470.885 546.612 445.233 506.863 407.813 484.246 C 424.316 466.556 433.433 443.484 433.375 419.568 C 433.375 366.542 389.543 323.622 335.519 323.622 C 281.497 323.622 237.663 366.542 237.663 419.568 C 237.663 444.497 247.326 467.114 263.225 484.246 C 224.558 507.615 200.078 547.97 197.695 592.273 C 197.344 596.213 200.506 599.468 204.547 599.468 Z M 335.431 375.023 C 360.467 375.023 380.846 394.982 380.846 419.568 C 380.846 444.155 360.467 464.115 335.431 464.115 C 310.397 464.115 290.018 444.155 290.018 419.568 C 290.018 394.982 310.397 375.023 335.431 375.023 Z"
        // style="mask: url('#mask-0');"
        style={{
          mask: "url('#mask-0')",
        }}
        transform="matrix(1, 0, 0, 1, 2.842170943040401e-14, 7.105427357601002e-15)"
      />
      <path
        d="M 846.609 790.86 L 831.147 790.86 L 825.341 786.242 C 843.71 765.004 855.313 738.218 855.313 707.745 C 855.311 641.251 799.24 587.689 729.653 587.689 C 661.016 587.689 604.954 641.251 604.954 707.745 C 604.954 774.239 661.016 827.799 730.615 827.799 C 761.549 827.799 790.546 816.716 812.777 799.173 L 818.573 803.792 L 818.573 818.565 L 915.234 910.914 L 944.233 883.21 L 846.609 790.86 Z M 733.206 783.191 C 684.874 783.191 650.096 753.918 650.096 707.745 C 650.096 661.569 680.987 632.3 729.319 632.3 C 777.649 632.3 808.541 661.569 808.541 707.745 C 808.541 753.918 781.536 783.191 733.206 783.191 Z"
        // style=""
        transform="matrix(1, 0, 0, 1, 2.842170943040401e-14, 7.105427357601002e-15)"
      />
    </svg>
  </SvgIcon>
))`
  height: 4rem;
  width: 4rem;
`;

export const MessagingServiceIcon = styled(TbMessage)`
  height: 3.5rem;
  width: 3.5rem;
`;

const ApplicationServiceSvgIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="108"
    >
      <g transform="translate(0,512) scale(0.1,-0.1)">
        <path
          d="M1525 5031 c-92 -23 -173 -91 -214 -176 -21 -42 -25 -70 -29 -172
l-4 -122 -188 -3 c-206 -3 -215 -6 -264 -72 -21 -27 -21 -30 -24 -1559 l-2
-1532 -324 -325 c-352 -354 -366 -372 -389 -504 -63 -367 361 -623 663 -401
28 21 52 36 53 34 2 -2 9 -17 17 -33 8 -16 30 -40 49 -55 l34 -26 1578 0 1578
0 27 21 c64 47 69 62 74 232 l5 156 345 63 c189 34 358 68 375 75 76 32 142
121 151 206 5 46 -443 3899 -466 4008 -20 97 -105 177 -201 190 -30 4 -392
-42 -1139 -145 -602 -83 -1107 -153 -1121 -155 -24 -5 -28 -1 -34 32 -18 102
-84 190 -178 239 -49 26 -61 28 -197 30 -80 1 -158 -2 -175 -6z m321 -177 c60
-44 69 -67 72 -185 l4 -109 -81 0 -81 0 0 80 0 80 -80 0 -80 0 0 -80 0 -80
-80 0 -80 0 0 94 c0 102 9 137 43 175 41 44 72 51 209 49 110 -3 130 -6 154
-24z m2537 6 c13 -11 27 -30 30 -42 3 -13 110 -909 237 -1992 218 -1846 231
-1971 217 -2001 -8 -17 -28 -37 -44 -43 -26 -11 -620 -122 -650 -122 -10 0
-13 362 -15 1899 l-3 1900 -21 27 c-11 15 -33 37 -48 48 -27 21 -37 21 -1019
26 -546 3 -987 7 -982 8 21 6 2212 310 2241 311 17 1 43 -8 57 -19z m-3103
-596 c0 -78 5 -154 12 -178 16 -55 99 -138 154 -154 94 -28 169 -8 239 63 66
65 75 99 75 269 l0 136 80 0 80 0 0 -160 0 -160 80 0 80 0 0 160 0 160 960 0
960 0 0 -2080 0 -2080 -1520 0 -1520 0 0 62 0 63 475 475 475 475 113 340 114
340 851 3 852 2 0 80 0 80 -888 0 -887 0 -375 -125 -375 -125 -177 -177 -178
-178 0 1423 0 1422 160 0 160 0 0 -136z m320 1 c0 -131 -1 -137 -25 -160 -15
-16 -36 -25 -55 -25 -19 0 -40 9 -55 25 -24 23 -25 29 -25 160 l0 135 80 0 80
0 0 -135z m347 -2327 c-2 -7 -13 -39 -23 -71 l-18 -57 -48 47 -49 48 63 22
c75 26 82 27 75 11z m-120 -364 l-21 -65 -148 148 -148 148 62 21 63 22 106
-105 106 -105 -20 -64z m-282 -34 l180 -180 -423 -423 -422 -422 -182 183
-183 182 420 420 c231 231 422 420 425 420 3 0 86 -81 185 -180z m-960 -960
l180 -180 -55 -56 c-79 -80 -118 -99 -210 -99 -57 0 -84 5 -115 22 -47 25 -95
74 -121 123 -26 48 -26 171 0 220 17 32 123 150 136 150 3 0 86 -81 185 -180z"
        />
        <path
          d="M2240 3440 l0 -800 800 0 800 0 0 800 0 800 -800 0 -800 0 0 -800z
m1440 0 l0 -640 -45 0 c-51 0 -44 -16 -76 170 -33 197 -107 327 -227 397 -23
14 -41 28 -39 32 53 98 62 128 62 206 -1 71 -4 87 -34 143 -38 70 -70 100
-145 140 -44 22 -63 26 -136 26 -100 0 -160 -24 -225 -89 -64 -63 -89 -125
-89 -220 -1 -77 11 -117 61 -206 2 -3 -19 -20 -46 -37 -124 -81 -182 -183
-218 -381 -13 -75 -26 -146 -29 -158 -4 -20 -11 -23 -49 -23 l-45 0 0 640 0
640 640 0 640 0 0 -640z m-577 306 c103 -43 128 -177 48 -257 -112 -113 -296
-12 -267 146 18 94 128 150 219 111z m112 -498 c62 -32 118 -88 145 -143 18
-37 60 -238 60 -287 0 -17 -25 -18 -380 -18 -355 0 -380 1 -380 18 0 49 42
250 60 287 35 73 114 138 200 166 14 5 75 7 135 6 96 -3 116 -6 160 -29z"
        />
        <path d="M1120 3680 l0 -80 480 0 480 0 0 80 0 80 -480 0 -480 0 0 -80z" />
        <path d="M1120 3360 l0 -80 480 0 480 0 0 80 0 80 -480 0 -480 0 0 -80z" />
        <path d="M1120 3040 l0 -80 480 0 480 0 0 80 0 80 -480 0 -480 0 0 -80z" />
        <path d="M1120 2720 l0 -80 480 0 480 0 0 80 0 80 -480 0 -480 0 0 -80z" />
        <path d="M1120 2400 l0 -80 1360 0 1360 0 0 80 0 80 -1360 0 -1360 0 0 -80z" />
        <path
          d="M2720 720 l0 -320 560 0 560 0 0 320 0 320 -560 0 -560 0 0 -320z
m960 0 l0 -160 -400 0 -400 0 0 160 0 160 400 0 400 0 0 -160z"
        />
        <path d="M1920 800 l0 -80 320 0 320 0 0 80 0 80 -320 0 -320 0 0 -80z" />
        <path d="M1920 480 l0 -80 320 0 320 0 0 80 0 80 -320 0 -320 0 0 -80z" />
      </g>
    </svg>
  </SvgIcon>
);

export const ApplicationServiceIcon = styled(ApplicationServiceSvgIcon)`
  height: 3.5rem;
  width: 3.5rem;
`;

export const BindingServiceIcon = styled(TbLayersLinked)`
  height: 3.5rem;
  width: 3.5rem;
`;

export const TaskServiceIcon = styled(TbListCheck)`
  height: 3.5rem;
  width: 3.5rem;
`;

export const CustomerManagementServiceIcon = styled(TbUserHexagon)`
  height: 3.5rem;
  width: 3.5rem;
`;

export const TransactionHistoryIcon = styled(MdHistory)`
  height: 1.5rem;
  width: 1.5rem;
`;

export const PendingReviewIcon = styled(RiPassPendingLine)`
  height: 1.5rem;
  width: 1.5rem;
`;

export const EkycFaceCompareIcon = styled(MdOutlineCompare)`
  height: 1.5rem;
  width: 1.5rem;
`;

export const FaceCaptureIcon = styled(MdOutlineSensorOccupied)`
  height: 1.5rem;
  width: 1.5rem;
`;

export const SmallCloseIcon = styled(BsXLg)`
  height: 1rem;
  width: 1rem;
  stroke-width: 1;
`;

export const ConfigActivatedIcon = styled(PiGear)`
  height: 1.4rem;
  width: 1.4rem;
  animation: spin 3s linear infinite;
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

export const ConfigDeactivatedIcon = styled(PiGear)`
  height: 1.4rem;
  width: 1.4rem;
`;

export const ConfigPlayIcon = styled(MdPlayArrow)`
  height: 1.4rem;
  width: 1.4rem;
`;

export const ConfigPauseIcon = styled(MdPause)`
  height: 1.4rem;
  width: 1.4rem;
`;

export const TOTPMfaIcon = styled(MdOutlineScreenLockPortrait)`
  height: 1.5rem;
  width: 1.5rem;
`;

export const EmailOTPMfaIcon = styled(MdOutlineMailLock)`
  height: 1.5rem;
  width: 1.5rem;
`;

export const UserMFAIcon = styled(TbPasswordUser)`
  height: 1.2rem;
  width: 1.2rem;
`;

export const TextFieldEnterIcon = styled(MdOutlineArrowForward)`
  height: 1.2rem;
  width: 1.2rem;
`;

export const ExpandRightSidebarIcon = styled(TbLayoutSidebarRightExpand)`
  height: 1.5rem;
  width: 1.5rem;
`;

export const CollapseRightSidebarIcon = styled(TbLayoutSidebarRightCollapse)`
  height: 1.5rem;
  width: 1.5rem;
`;

export const Layout1ColumnIcon = styled(TbColumns1)`
  height: 1.5rem;
  width: 1.5rem;
`;

export const Layout2ColumnsIcon = styled(LuColumns2)`
  height: 1.5rem;
  width: 1.5rem;
`;

export const Layout3ColumnsIcon = styled(LuColumns3)`
  height: 1.5rem;
  width: 1.5rem;
`;

export const Layout4ColumnsIcon = styled(LuColumns4)`
  height: 1.5rem;
  width: 1.5rem;
`;

export const ExpandComponentSpanIcon = styled(BiExpandHorizontal)`
  height: 1.2rem;
  width: 1.2rem;
`;

export const CollapseComponentSpanIcon = styled(BiCollapseHorizontal)`
  height: 1.2rem;
  width: 1.2rem;
`;

export const ExpandComponentHeightIcon = styled(BiExpandVertical)`
  height: 1.2rem;
  width: 1.2rem;
`;

export const CollapseComponentHeightIcon = styled(BiCollapseVertical)`
  height: 1.2rem;
  width: 1.2rem;
`;

const ApplicationFormSvgIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      preserveAspectRatio="xMidYMid meet"
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="108"
    >
      <g transform="translate(0,512) scale(0.1,-0.1)">
        <path
          d="M516 4969 c-166 -39 -326 -201 -365 -369 -15 -63 -15 -4017 0 -4080
39 -170 199 -330 369 -369 62 -15 3108 -15 3170 0 122 28 255 128 317 239 67
118 66 115 70 660 l4 495 408 410 c332 334 412 420 435 466 94 192 71 402 -60
563 -92 114 -228 176 -384 176 -142 0 -247 -42 -355 -141 l-45 -42 0 450 c0
448 0 450 -22 491 -13 23 -245 260 -540 551 l-516 511 -1224 -1 c-704 -1
-1240 -5 -1262 -10z m2344 -456 c0 -367 19 -446 136 -573 64 -68 127 -111 210
-142 55 -20 80 -22 362 -26 l302 -4 0 -501 0 -502 -661 -660 c-363 -363 -666
-671 -673 -685 -21 -39 -226 -801 -226 -839 0 -43 46 -91 89 -91 17 0 194 45
393 99 200 54 383 104 408 111 40 10 78 45 358 323 l312 312 0 -376 c0 -440 0
-440 -89 -530 -98 -97 59 -89 -1680 -89 l-1526 0 -55 26 c-73 34 -116 76 -151
149 l-29 60 0 1980 c0 2256 -9 2036 90 2135 96 96 -13 88 1288 89 l1142 1 0
-267z m860 -536 c0 -5 -93 -7 -207 -5 -199 3 -210 4 -263 29 -78 37 -114 71
-149 141 l-31 61 0 216 0 216 325 -325 c179 -179 325 -329 325 -333z m885
-1046 c63 -28 109 -72 143 -136 23 -43 27 -62 27 -135 0 -73 -4 -92 -27 -135
-14 -27 -49 -72 -77 -100 l-51 -50 -213 213 -212 213 65 62 c80 76 135 99 230
93 39 -2 86 -12 115 -25z m-340 -491 l210 -210 -643 -643 -642 -642 -212 213
-213 212 640 640 c352 352 642 640 645 640 3 0 100 -95 215 -210z m-1275
-1581 c0 -9 -420 -123 -427 -116 -3 4 20 104 52 222 l59 216 158 -158 c87 -87
158 -161 158 -164z"
        />
        <path
          d="M604 4370 c-12 -4 -31 -21 -43 -36 -20 -26 -21 -35 -21 -361 l0 -335
34 -34 35 -35 340 3 341 3 27 28 28 27 0 345 0 345 -28 27 -27 28 -333 2
c-182 1 -342 -2 -353 -7z m541 -395 l0 -200 -202 -3 -203 -2 0 205 0 205 203
-2 202 -3 0 -200z"
        />
        <path
          d="M1614 4270 c-12 -4 -31 -21 -44 -37 -29 -37 -23 -98 15 -130 l26 -23
495 0 496 0 29 29 c40 40 40 89 0 133 l-29 33 -484 2 c-266 1 -493 -2 -504 -7z"
        />
        <path
          d="M1585 3847 c-17 -14 -28 -36 -32 -63 -5 -36 -1 -46 25 -75 l30 -34
345 0 345 0 25 23 c32 30 41 65 27 107 -21 65 -22 65 -399 65 -338 0 -340 0
-366 -23z"
        />
        <path
          d="M604 3256 c-64 -28 -64 -26 -64 -389 0 -356 2 -371 55 -395 18 -9
121 -12 355 -12 l330 0 32 29 33 29 3 331 c3 370 2 380 -63 407 -49 20 -635
20 -681 0z m546 -396 l0 -200 -205 0 -205 0 0 200 0 200 205 0 205 0 0 -200z"
        />
        <path
          d="M1624 3159 c-42 -12 -65 -40 -71 -87 -4 -33 -1 -44 25 -73 l30 -34
497 0 497 0 29 33 c53 59 29 140 -49 162 -46 12 -914 12 -958 -1z"
        />
        <path
          d="M1601 2746 c-47 -26 -63 -84 -37 -135 26 -49 42 -51 396 -51 l330 0
32 29 c27 24 33 36 33 71 0 35 -6 47 -33 71 l-32 29 -333 0 c-256 -1 -337 -4
-356 -14z"
        />
        <path
          d="M573 2126 l-28 -24 0 -352 0 -352 28 -24 28 -24 340 0 c375 0 377 0
398 62 7 20 11 147 11 345 0 334 -3 358 -49 383 -13 6 -146 10 -360 10 l-340
0 -28 -24z m577 -376 l0 -200 -205 0 -205 0 0 200 0 200 205 0 205 0 0 -200z"
        />
        <path
          d="M1597 2039 c-23 -13 -47 -62 -47 -95 0 -16 12 -38 34 -60 l34 -34
481 0 c529 0 526 0 551 59 17 42 5 95 -27 121 -25 20 -37 20 -517 20 -315 0
-497 -4 -509 -11z"
        />
        <path
          d="M1584 1616 c-21 -21 -34 -44 -34 -60 0 -35 25 -83 49 -96 28 -15 672
-14 705 1 33 15 59 71 51 108 -3 16 -17 39 -31 52 l-26 24 -339 3 -340 3 -35
-35z"
        />
      </g>
    </svg>
  </SvgIcon>
);

export const UserApplicationSvgIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      preserveAspectRatio="xMidYMid meet"
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="108"
    >
      <g transform="translate(0,512) scale(0.1,-0.1)">
        <path
          d="M593 5102 c-73 -26 -136 -81 -170 -150 l-28 -57 -3 -555 c-2 -379 1
-562 8 -580 26 -63 113 -75 161 -24 l24 26 5 546 c3 301 9 554 13 563 5 9 23
24 40 33 30 16 146 17 1529 14 l1498 -3 27 -28 28 -27 0 -1900 0 -1900 -28
-27 -27 -28 -1498 -3 c-1372 -3 -1500 -2 -1528 13 -18 10 -37 28 -43 41 -8 18
-11 295 -11 969 0 575 -4 954 -10 969 -23 61 -112 79 -159 32 l-26 -26 0 -988
0 -987 29 -58 c19 -39 44 -71 78 -98 94 -74 -21 -70 1678 -67 l1525 3 46 21
c60 28 119 87 150 150 l24 49 0 1935 0 1935 -24 49 c-31 63 -90 122 -150 150
l-46 21 -1530 2 c-1450 2 -1533 2 -1582 -15z"
        />
        <path
          d="M4195 4711 c-11 -5 -29 -19 -40 -31 -20 -22 -20 -40 -25 -2019 -5
-2130 -3 -2025 -50 -2048 -8 -5 -648 -10 -1422 -13 l-1406 -5 -26 -24 c-51
-48 -39 -135 23 -161 18 -7 463 -9 1441 -8 l1415 3 58 29 c39 19 71 44 98 78
75 95 69 -74 67 2151 l-3 1997 -25 25 c-28 27 -74 39 -105 26z"
        />
        <path
          d="M998 4363 c-14 -9 -31 -27 -37 -40 -16 -34 -15 -1013 0 -1047 6 -13
25 -32 43 -41 28 -14 82 -16 538 -13 l508 3 27 28 28 27 0 520 0 520 -28 27
-27 28 -513 2 c-464 3 -515 1 -539 -14z m912 -563 l0 -380 -380 0 -380 0 0
380 0 380 380 0 380 0 0 -380z"
        />
        <path
          d="M2518 4363 c-65 -41 -62 -132 6 -168 28 -14 73 -16 408 -13 l378 3
27 27 c38 39 38 97 0 136 l-27 27 -383 2 c-343 3 -385 1 -409 -14z"
        />
        <path
          d="M4595 4311 c-11 -5 -29 -19 -40 -31 -20 -22 -20 -40 -25 -2019 -3
-1098 -8 -2003 -13 -2011 -23 -47 53 -45 -1659 -50 l-1608 -5 -27 -27 c-38
-39 -38 -97 0 -136 l27 -27 1607 -3 c1791 -2 1667 -7 1761 67 34 27 59 59 78
98 l29 58 3 2005 c1 1390 -1 2013 -8 2031 -19 45 -78 69 -125 50z"
        />
        <path
          d="M2518 3883 c-65 -41 -62 -132 6 -168 28 -14 73 -16 408 -13 l378 3
27 27 c38 39 38 97 0 136 l-27 27 -383 2 c-343 3 -385 1 -409 -14z"
        />
        <path
          d="M434 3432 c-51 -41 -57 -97 -16 -143 23 -26 36 -32 71 -32 72 0 114
59 91 128 -20 60 -99 86 -146 47z"
        />
        <path
          d="M2518 3403 c-65 -41 -62 -132 6 -168 28 -14 73 -16 408 -13 l378 3
27 27 c38 39 38 97 0 136 l-27 27 -383 2 c-343 3 -385 1 -409 -14z"
        />
        <path
          d="M1430 2645 l-146 -145 -44 46 c-106 109 -166 130 -221 75 -23 -23
-29 -38 -29 -72 0 -40 5 -46 118 -160 119 -120 147 -137 200 -125 40 10 398
372 405 410 11 63 -33 116 -97 116 -38 0 -47 -7 -186 -145z"
        />
        <path
          d="M2108 2613 c-65 -41 -62 -132 6 -168 28 -14 90 -16 644 -13 l614 3
24 28 c33 38 33 96 0 134 l-24 28 -619 2 c-563 3 -620 1 -645 -14z"
        />
        <path
          d="M1429 1883 l-149 -146 -73 71 c-79 76 -111 91 -157 72 -38 -16 -60
-51 -60 -97 0 -34 10 -47 123 -160 120 -120 124 -123 167 -123 43 0 45 1 228
183 101 100 190 196 197 212 7 17 11 42 8 58 -8 39 -57 77 -100 77 -32 0 -49
-13 -184 -147z"
        />
        <path
          d="M2108 1853 c-65 -41 -62 -132 6 -168 28 -14 90 -16 644 -13 l614 3
24 28 c33 38 33 96 0 134 l-24 28 -619 2 c-563 3 -620 1 -645 -14z"
        />
        <path
          d="M855 591 c-32 -14 -55 -46 -62 -84 -5 -32 -1 -41 30 -72 25 -25 44
-35 67 -35 23 0 42 10 67 35 31 31 35 40 30 72 -11 64 -78 107 -132 84z"
        />
      </g>
    </svg>
  </SvgIcon>
);

export const ApplicationFormIcon = styled(ApplicationFormSvgIcon)`
  height: 1.5rem;
  width: 1.5rem;
`;

export const UserApplicationIcon = styled(UserApplicationSvgIcon)`
  height: 1.5rem;
  width: 1.5rem;
`;

export const ApplicationPendingProcessIcon = styled(MdOutlineApproval)`
  height: 1.5rem;
  width: 1.5rem;
`;

export const ApplicationOngoingIcon = styled(MdOutlineLoop)`
  height: 1.5rem;
  width: 1.5rem;
  transform: rotate(45deg) scaleX(-1);
`;

export const AddApplicationFormIcon = styled(LuFilePlus2)`
  height: 1.5rem;
  width: 1.5rem;
`;

export const ApplicationFormItemSchemaIcon = styled(LuFileJson2)`
  height: 1.5rem;
  width: 1.5rem;
  color: inherit;
`;

export const ApplicationFormDisplaySchemaIcon = styled(LuFilePen)`
  height: 1.5rem;
  width: 1.5rem;
  color: inherit;
`;

export const DuplicateApplicationFormIcon = styled(LuFiles)`
  height: 1.2rem;
  width: 1.2rem;
  color: inherit;
`;

export const ApplicationFormPublishIcon = styled(LuGlobe)`
  height: 1.2rem;
  width: 1.2rem;
  color: inherit;
`;

export const ApplicationFormDeprecateIcon = styled(PiGlobeSimpleXBold)`
  height: 1.2rem;
  width: 1.2rem;
  color: inherit;
`;

const BrowserEditSvgIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      fill="none"
    >
      <path
        d="M4 8h16"
        transform="matrix(1, 0, 0, 1, 0, -2.220446049250313e-16)"
      />
      <path
        d="M11 19.5h-5a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v5"
        transform="matrix(1, 0, 0, 1, 0, -2.220446049250313e-16)"
      />
      <path
        d="M8 4v4"
        transform="matrix(1, 0, 0, 1, 0, -2.220446049250313e-16)"
      />
      <path
        strokeWidth="1"
        d="M 18.706 13.785 L 20.796 15.915 L 18.706 13.785 Z M 22.081 14.113 C 22.252 14.284 22.251 14.564 22.077 14.737 L 16.198 20.582 L 13.1 21.462 L 13.985 18.382 L 19.864 12.538 C 20.038 12.364 20.319 12.361 20.492 12.534 L 22.081 14.113 Z M 13.542 20.142 L 14.427 21.022 M 15.312 19.262 L 18.852 15.743"
        transform="matrix(1, 0, 0, 1, 0, -2.220446049250313e-16)"
      />
    </svg>
  </SvgIcon>
);

export const BrowserEditIcon = styled(BrowserEditSvgIcon)`
  height: 1.8rem;
  width: 1.8rem;
  color: inherit;
`;

export const SchemaDownloadIcon = styled(TbDownload)`
  height: 1.2rem;
  width: 1.2rem;
`;

export const SchemaUploadIcon = styled(TbUpload)`
  height: 1.2rem;
  width: 1.2rem;
`;

export const SchemaUndoIcon = styled(LuUndo2)`
  height: 1.2rem;
  width: 1.2rem;
`;

export const ExpandMenuIcon = styled(MdArrowDropDown)`
  height: 1.5rem;
  width: 1.5rem;
`;

export const FindRecordIcon = styled(MdOutlineSearch)`
  height: 1.2rem;
  width: 1.2rem;
`;

export const CsvFileIcon = styled(TbFileTypeCsv)`
  height: 1.2rem;
  width: 1.2rem;
`;

export const XlsxFileIcon = styled(TbFileSpreadsheet)`
  height: 1.2rem;
  width: 1.2rem;
`;

export const ZipFileIcon = styled(MdOutlineFolderZip)`
  height: 1.2rem;
  width: 1.2rem;
`;

export const SchemaDrawerCollapseIcon = styled(MdOutlineKeyboardArrowRight)`
  height: 1.2rem;
  width: 1.2rem;
`;

export const SchemaDrawerExpandIcon = styled(MdOutlineKeyboardArrowLeft)`
  height: 1.2rem;
  width: 1.2rem;
`;

export const JournalCreateSvgIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16.813 16.813"
      stroke="currentColor"
    >
      <g transform="translate(-781.307 -1242.938)">
        <g transform="translate(-16.923)">
          <path
            d="M6780.313,1254.875h4.074"
            transform="translate(-5974.813 -4.531)"
            fill="none"
            strokeWidth="1"
          />
          <path
            d="M6780.313,1254.875h5.651"
            transform="translate(-5976.39 -6.531)"
            fill="none"
            strokeWidth="1"
          />
          <path
            d="M6780.313,1254.875h4.074"
            transform="translate(-5974.813 -2.531)"
            fill="none"
            strokeWidth="1"
          />
        </g>
        <g transform="translate(-1.193 0.844)">
          <path
            d="M6780.313,1254.875h5.759"
            transform="translate(-5997.813 -1.375)"
            fill="none"
            strokeWidth="1.5"
          />
          <path
            d="M6780.313,1254.875h5.759"
            transform="translate(2040.375 -5529.813) rotate(90)"
            fill="none"
            strokeWidth="1.5"
          />
        </g>
        <path
          d="M6754.875,1248.132v-6.445h7.451l3.892,3.892V1257h-11.989"
          transform="translate(-5970.729 2)"
          fill="none"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  </SvgIcon>
);

export const JournalSubmitSvgIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      viewBox="0 0 16.813 16.813"
    >
      <g transform="translate(-755.505 -1242.938)">
        <g transform="translate(-43.214)">
          <path
            d="M6780.313,1254.875h4.074"
            transform="translate(-5974.813 -4.531)"
            fill="none"
            strokeWidth="1"
          />
          <path
            d="M6780.313,1254.875h5.651"
            transform="translate(-5976.39 -6.531)"
            fill="none"
            strokeWidth="1"
          />
          <path
            d="M6780.313,1254.875h4.074"
            transform="translate(-5974.813 -2.531)"
            fill="none"
            strokeWidth="1"
          />
        </g>
        <path
          d="M6780.313,1254.875h4.284"
          transform="translate(-6023.646 -1.8)"
          fill="none"
          strokeWidth="1.5"
        />
        <path
          d="M6780.313,1254.875h5.416"
          transform="translate(-6024.808 1.125)"
          fill="none"
          strokeWidth="1.5"
        />
        <path
          d="M6754.875,1248.132v-6.445h7.451l3.892,3.892V1257h-11.989"
          transform="translate(-5996.688 2)"
          fill="none"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  </SvgIcon>
);

const CaseManagerSvgIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 18.593 19.901"
      fill="currentColor"
    >
      <g transform="translate(-60.217 -132.899)">
        <g transform="translate(-95.033 -228.101)">
          <path
            d="M41.163,42.86h-7.57l-2.441-2.441A1.419,1.419,0,0,0,30.14,40H25.43A1.43,1.43,0,0,0,24,41.43V54.358a1.377,1.377,0,0,0,1.376,1.375H41.242a1.352,1.352,0,0,0,1.351-1.351V44.291A1.43,1.43,0,0,0,41.163,42.86ZM25.43,41.43h4.71l1.43,1.43H25.43Z"
            transform="translate(131.25 325.169)"
            strokeWidth="0"
          />
          <path
            d="M13.228,4.766H5.845L3.4,2.324A1.429,1.429,0,0,0,2.4,1.9H0V0H11.728a1.5,1.5,0,0,1,1.5,1.5V4.765Z"
            transform="translate(159.5 362.5)"
            strokeWidth="1"
          />
        </g>
        <g transform="translate(65.514 139.412)">
          <path
            d="M4,12H4"
            transform="translate(0 -3.537)"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
          />
          <path
            d="M4,6H4"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
          />
          <path
            d="M4,18H4"
            transform="translate(0 -7.075)"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
          />
          <path
            d="M8,18h.821"
            transform="translate(-2.358 -7.075)"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
          />
          <path
            d="M8,12h.821"
            transform="translate(-2.358 -3.537)"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
          />
          <path
            d="M8,6h.821"
            transform="translate(-2.358)"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
          />
          <path
            d="M14,6h2.463"
            transform="translate(-5.896)"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
          />
          <path
            d="M14,12h2.463"
            transform="translate(-5.896 -3.537)"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
          />
          <path
            d="M14,18h2.463"
            transform="translate(-5.896 -7.075)"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
          />
        </g>
      </g>
    </svg>
  </SvgIcon>
);

export const CaseManagerIcon = styled(CaseManagerSvgIcon)`
  height: 1.3rem;
  width: 1.3rem;
`;

// export const CreateCaseIcon = styled(MdOutlineCreateNewFolder)`
//   height: 1.5rem;
//   width: 1.5rem;
// `;

export const CreateCaseSvgIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg
      stroke="currentColor"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
    >
      <path
        id="createcase"
        d="M4,1V4H1V6H4V9H6V6H9V4H6V1Zm7,4a6,6,0,0,1-8,5.659v9.348A1,1,0,0,0,4,21H14V15a1,1,0,0,1,1-1h6V4a1,1,0,0,0-.993-1H10.659A5.99,5.99,0,0,1,11,5ZM21,16l-5,5V16Z"
        transform="translate(-1 -1)"
        fill="inherit"
        strokeWidth="0"
      />
    </svg>
  </SvgIcon>
);

export const CreateCaseIcon = styled(CreateCaseSvgIcon)`
  height: 1.3rem;
  width: 1.3rem;
`;

export const CaseRecordSvgIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg
      stroke="currentColor"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20.6 18.6"
    >
      <g transform="translate(-61.9 -253.9)">
        <path
          d="M11,5a6,6,0,0,1-8,5.659v9.348A1,1,0,0,0,4,21H14V15a1,1,0,0,1,1-1h6V4a1,1,0,0,0-.993-1H10.659A5.99,5.99,0,0,1,11,5ZM21,16l-5,5V16Z"
          transform="translate(61.5 251.5)"
          strokeWidth="0"
        />
        <g transform="translate(58.5 248.5)">
          <path
            d="M4,12H4"
            transform="translate(0 -3.537)"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
          />
          <path
            d="M4,6H4"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
          />
          <path
            d="M4,18H4"
            transform="translate(0 -7.075)"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
          />
          <path
            d="M8,18h.821"
            transform="translate(-2.358 -7.075)"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
          />
          <path
            d="M8,12h.821"
            transform="translate(-2.358 -3.537)"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
          />
          <path
            d="M8,6h.821"
            transform="translate(-2.358)"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
          />
          <path
            d="M14,6h2.463"
            transform="translate(-5.896)"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
          />
          <path
            d="M14,12h2.463"
            transform="translate(-5.896 -3.537)"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
          />
          <path
            d="M14,18h2.463"
            transform="translate(-5.896 -7.075)"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
          />
        </g>
      </g>
    </svg>
  </SvgIcon>
);

export const CaseRecordIcon = styled(CaseRecordSvgIcon)`
  height: 1.3rem;
  width: 1.3rem;
`;

export const CaseChangeMemberSvgIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 22.731 21.737"
      fill="currentColor"
    >
      <path
        d="M9.143,11.572A.572.572,0,1,1,8.572,11,.572.572,0,0,1,9.143,11.572Z"
        transform="translate(1.079 -0.703)"
        strokeWidth="0"
      />
      <path
        d="M14.572,12.143A.572.572,0,1,0,14,11.572.572.572,0,0,0,14.572,12.143Z"
        transform="translate(-1.492 -0.703)"
        strokeWidth="0"
      />
      <path
        d="M7.73,2H7.716a5.712,5.712,0,1,0,.45.017h0Q7.947,2,7.73,2ZM7.716,12.289A4.577,4.577,0,0,0,12.141,6.56a5.725,5.725,0,0,1-5.134-2.5A4.559,4.559,0,0,1,3.754,5.431a4.574,4.574,0,0,0,3.962,6.858ZM7.7,3.143h0Z"
        transform="translate(3.649 3.152)"
        strokeWidth="0"
        fillRule="evenodd"
      />
      <path
        d="M20.924,16.241A8.695,8.695,0,0,0,8.6,5.32L7.518,3.433a10.868,10.868,0,0,1,15.3,13.9l1.458.842L19.75,20.582l-.179-5.123ZM4.9,9.5A8.695,8.695,0,0,0,17.224,20.418L18.3,22.306A10.868,10.868,0,0,1,3,8.4L1.545,7.562,6.071,5.156l.179,5.123Z"
        transform="translate(-1.545 -2.001)"
        strokeWidth="0"
      />
    </svg>
  </SvgIcon>
);

export const EkycOCRSvgIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 512 512"
      fill="currentColor"
    >
      <g>
        <path
          d="M145 482H30V367H0v145h145zM482 367v115H367v30h145V367zM30 145V30h115V0H0v145zM367 0v30h115v115h30V0zM122.293 171.934c-28.292 0-51.31 23.018-51.31 51.31v65.35c0 28.292 23.018 51.31 51.31 51.31 28.293 0 51.311-23.018 51.311-51.31v-65.35c0-28.293-23.018-51.31-51.311-51.31zm21.311 116.659c0 11.75-9.559 21.31-21.311 21.31-11.75 0-21.31-9.56-21.31-21.31v-65.35c0-11.75 9.56-21.31 21.31-21.31 11.751 0 21.311 9.56 21.311 21.31zM255.452 201.934c11.75 0 21.309 9.56 21.309 21.31h30c0-28.292-23.018-51.31-51.309-51.31-28.292 0-51.31 23.018-51.31 51.31v65.35c0 28.292 23.018 51.31 51.31 51.31s51.309-23.018 51.309-51.31h-30c0 11.75-9.559 21.31-21.309 21.31s-21.31-9.56-21.31-21.31v-65.35c.001-11.751 9.56-21.31 21.31-21.31zM418.245 265.298c14.382-9.099 23.902-24.751 23.902-42.508 0-28.042-23.725-50.857-52.886-50.857h-51.663v167.969h30v-66.256h21.663c.052 0 .103-.004.154-.004l21.368 66.423h31.514zm-50.647-63.364h21.663c12.405 0 22.886 9.551 22.886 20.857 0 11.305-10.481 20.857-22.886 20.857h-21.663z"
          opacity="1"
        ></path>
      </g>
    </svg>
  </SvgIcon>
);

export const CircleIpSvgIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
      <g transform="translate(6 2.007)">
        <text
          transform="translate(-1 12.993)"
          fill="#707070"
          fontSize="12"
          fontWeight="700"
          letterSpacing="-0.03em"
        >
          <tspan x="0" y="0">
            IP
          </tspan>
        </text>
      </g>
      <g>
        <path
          d="M12,2A10,10,0,1,0,22,12,10.011,10.011,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8.009,8.009,0,0,1,12,20Z"
          transform="translate(-2 -2)"
          fill="#707070"
          stroke="#000"
          strokeWidth="0"
        />
      </g>
    </svg>
  </SvgIcon>
);

export const InfoPhoneSvgIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.5 22.5">
      <g transform="translate(0.75 0.75)">
        <path
          d="M10.5,1.5H8.25A2.25,2.25,0,0,0,6,3.75v16.5A2.25,2.25,0,0,0,8.25,22.5h7.5A2.25,2.25,0,0,0,18,20.25V3.75A2.25,2.25,0,0,0,15.75,1.5H13.5m-3,0V3h3V1.5m-3,0h3m-3,18.75h3"
          transform="translate(-6 -1.5)"
          fill="none"
          stroke="#707070"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M8.93,6.588l-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738,3.468c-.194.9.105,1.319.808,1.319A2.071,2.071,0,0,0,8.831,12l.088-.416a1.108,1.108,0,0,1-.686.246c-.275,0-.375-.193-.3-.533ZM9,4.5a1,1,0,1,1-1-1,1,1,0,0,1,1,1"
          transform="translate(-1.75 1.953)"
          fill="#707070"
          stroke="#000"
          strokeWidth="0"
        />
      </g>
    </svg>
  </SvgIcon>
);

export const TransactionIdSvgIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 18 20"
      fill="currentColor"
      stroke="currentColor"
    >
      <g transform="translate(-1232 -122)">
        <g transform="translate(1229 120)">
          <path
            d="M6,2A3,3,0,0,0,3,5V19a3,3,0,0,0,3,3H18a3,3,0,0,0,3-3V9a7,7,0,0,0-7-7ZM6,4h7V9h6V19a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1V5A1,1,0,0,1,6,4Zm9,.1A5.009,5.009,0,0,1,18.584,7H15Z"
            strokeWidth="0"
            fillRule="evenodd"
          />
        </g>
        <g transform="translate(1237 126.007)">
          <text
            transform="translate(-2 12.993)"
            fontSize="12"
            fontWeight="400"
            letterSpacing="-0.04em"
          >
            <tspan x="0" y="0">
              Tx
            </tspan>
          </text>
        </g>
      </g>
    </svg>
  </SvgIcon>
);

export const EkycHighRiskLevelSvgIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 13">
      <defs>
        <clipPath>
          <rect fill="none" />
        </clipPath>
      </defs>
      <g clipPath="url(#clip-path)">
        <path
          d="M20.949,9.476c-.191-1.081-6.792-.788-8-.569a2.125,2.125,0,0,0-1.841,2.353,2.1,2.1,0,0,0,2.534,1.56c1.207-.219,7.5-2.263,7.307-3.344"
          fill="currentColor"
        />
        <path
          d="M4.682,3.045A12.953,12.953,0,0,0,0,13H4A8.97,8.97,0,0,1,7.083,6.239Z"
          fill="currentColor"
        />
        <path
          d="M21.325,3.036l-2.408,3.2A8.97,8.97,0,0,1,22,13h4a12.966,12.966,0,0,0-4.675-9.964"
          fill="currentColor"
        />
        <path
          d="M20.279,2.249A12.937,12.937,0,0,0,5.717,2.238l.49.659,1.917,2.55a8.924,8.924,0,0,1,9.748,0Z"
          fill="currentColor"
        />
      </g>
    </svg>
  </SvgIcon>
);

export const EkycMediumRiskLevelSvgIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 13">
      <defs>
        <clipPath>
          <rect fill="none" />
        </clipPath>
      </defs>
      <g clipPath="url(#clip-path)">
        <path
          d="M4.682,3.045A12.953,12.953,0,0,0,0,13H4A8.97,8.97,0,0,1,7.083,6.239Z"
          fill="currentColor"
        />
        <path
          d="M21.325,3.036l-2.408,3.2A8.97,8.97,0,0,1,22,13h4a12.966,12.966,0,0,0-4.675-9.964"
          fill="currentColor"
        />
        <path
          d="M13,0A12.92,12.92,0,0,0,5.717,2.238l.49.658L8.125,5.447a8.969,8.969,0,0,1,3.667-1.358,3.693,3.693,0,0,1,.7-1.313A.917.917,0,0,1,13.14,2.5c.537.011.954.679,1.281,1.621A8.969,8.969,0,0,1,17.873,5.45l2.407-3.2A12.912,12.912,0,0,0,13,0"
          fill="currentColor"
        />
        <path
          d="M13.129,3c-1.1-.023-2.1,6.509-2.116,7.736A2.125,2.125,0,0,0,12.963,13a2.1,2.1,0,0,0,2.023-2.181c.021-1.228-.76-7.8-1.857-7.819"
          fill="currentColor"
        />
      </g>
    </svg>
  </SvgIcon>
);

export const EkycLowRiskLevelSvgIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 13">
      <defs>
        <clipPath>
          <rect fill="none" />
        </clipPath>
      </defs>
      <g clipPath="url(#clip-path)">
        <path
          d="M11.085,9.476c.191-1.081,6.792-.788,8-.569a2.125,2.125,0,0,1,1.841,2.353,2.1,2.1,0,0,1-2.534,1.56c-1.207-.219-7.5-2.263-7.307-3.344"
          transform="translate(-6.034)"
          fill="currentColor"
        />
        <path
          d="M2.4,3.045A12.953,12.953,0,0,1,7.083,13h-4A8.97,8.97,0,0,0,0,6.239Z"
          transform="translate(18.917)"
          fill="currentColor"
        />
        <path
          d="M23.592,3.036,26,6.239A8.97,8.97,0,0,0,22.917,13h-4a12.966,12.966,0,0,1,4.675-9.964"
          transform="translate(-18.917)"
          fill="currentColor"
        />
        <path
          d="M5.717,2.249a12.937,12.937,0,0,1,14.562-.011l-.49.659-1.917,2.55a8.924,8.924,0,0,0-9.748,0Z"
          transform="translate(0.004)"
          fill="currentColor"
        />
      </g>
    </svg>
  </SvgIcon>
);

export const CreateApplicationSvgIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 17.874 21.843"
      fill="currentColor"
      stroke="currentColor"
    >
      <g transform="translate(494 -5853.02)">
        <g transform="translate(-2515 -1889.98)">
          <g transform="translate(1994 7563)">
            <g transform="translate(0 0.571)">
              <g transform="translate(24 178.429)">
                <path
                  d="M13.921,2H5.984A1.984,1.984,0,0,0,4,3.984V19.858a1.984,1.984,0,0,0,1.984,1.984H17.89a1.984,1.984,0,0,0,1.984-1.984V7.953Z"
                  transform="translate(0 0)"
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                />
                <path
                  d="M14,2V7.953h5.953"
                  transform="translate(-0.079 0)"
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                />
              </g>
            </g>
          </g>
          <path
            d="M114.923,150.642v-2.125H112.8a.8.8,0,1,1,0-1.594h2.125V144.8a.8.8,0,0,1,1.594,0v2.125h2.125a.8.8,0,0,1,0,1.594h-2.125v2.125a.8.8,0,1,1-1.594,0Z"
            transform="translate(1914.217 7608.5)"
            stroke="#000"
            strokeWidth="0"
          />
        </g>
      </g>
    </svg>
  </SvgIcon>
);

export const UploadApplicationDocumentSvgIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 54 46.286"
      fill="currentColor"
    >
      <g transform="translate(-32.035 -64.03)">
        <path
          d="M83.331,73.212l-9.944-.482-.579-6.485a2.489,2.489,0,0,0-2.76-2.206L34.381,66.968a2.46,2.46,0,0,0-2.338,2.616L34.6,98.006a2.5,2.5,0,0,0,2.76,2.206l1.808-.145-.289,5.521a2.738,2.738,0,0,0,2.7,2.833l39.79,1.892a2.765,2.765,0,0,0,2.989-2.555L86.032,76.02A2.725,2.725,0,0,0,83.331,73.212Zm-42.779.639L39.7,90.1l-2.109,2.977L35.647,71.62V71.5A1.306,1.306,0,0,1,36.8,70.367l31.46-2.58a1.163,1.163,0,0,1,1.266.952c0,.024.036.024.036.048s.036.024.036.048l.325,3.713-26.4-1.266a2.781,2.781,0,0,0-2.977,2.567Zm40.26,28.555L70.591,90.412l-4.508,4.134-8.341-9.739-14.79,15.754,1.254-24v-.048a1.378,1.378,0,0,1,1.434-1.085l35.1,1.688a1.28,1.28,0,0,1,1.254,1.229c0,.024.036.036.036.06l-1.217,24Z"
          transform="translate(0 0)"
          fill="currentColor"
          stroke="#000"
          strokeWidth="0"
        />
        <path
          d="M355.857,199.714A3.857,3.857,0,1,0,352,195.857,3.869,3.869,0,0,0,355.857,199.714Z"
          transform="translate(-281.397 -112.545)"
          fill="currentColor"
          stroke="#000"
          strokeWidth="0"
        />
      </g>
    </svg>
  </SvgIcon>
);
export const UploadApplicationDocumentErrorSvgIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 60.246 46.3"
      fill="currentColor"
      stroke="none"
    >
      <defs>
        <clipPath id="clip-path">
          <rect
            width="60.246"
            height="46.3"
            transform="translate(0 0)"
            fill="none"
          />
        </clipPath>
      </defs>
      <g transform="translate(0 0)">
        <g clipPath="url(#clip-path)">
          <path d="M50,32.008c-.3,0-.6-.026-.9-.045l-.326,6.42h0L38.553,26.39l-4.508,4.134L25.7,20.785,10.914,36.539l1.254-24v-.048A1.378,1.378,0,0,1,13.6,11.406l23.506,1.13a14.037,14.037,0,0,1,4.1-5.417l-.437-4.9A2.489,2.489,0,0,0,38.029.015l-.019,0L2.343,2.946A2.459,2.459,0,0,0,0,5.52c0,.014,0,.028,0,.042L2.562,33.984a2.5,2.5,0,0,0,2.76,2.206l1.808-.145-.289,5.521A2.739,2.739,0,0,0,9.482,44.4h.059l39.79,1.892a2.765,2.765,0,0,0,2.987-2.524l0-.031.636-12.048a14.008,14.008,0,0,1-2.959.32M8.508,9.827l.006,0L7.662,26.078,5.553,29.055,3.609,7.6v-.12A1.306,1.306,0,0,1,4.762,6.345l31.46-2.58a1.163,1.163,0,0,1,1.266.952c0,.024.036.024.036.048s.036.024.036.048l.325,3.713L11.485,7.26A2.781,2.781,0,0,0,8.508,9.827" />
          <path d="M49.995,11.858a1.025,1.025,0,0,1,1.025,1.025v6.149a1.025,1.025,0,1,1-2.05,0V12.883a1.025,1.025,0,0,1,1.025-1.025" />
          <path d="M49.995,22.107a1.025,1.025,0,1,0,1.025,1.025,1.025,1.025,0,0,0-1.025-1.025" />
          <path
            d="M49.995,7.759A10.249,10.249,0,1,0,60.246,18.008,10.249,10.249,0,0,0,49.995,7.759ZM41.8,18.008a8.2,8.2,0,1,0,8.2-8.2,8.2,8.2,0,0,0-8.2,8.2"
            fillRule="evenodd"
          />
        </g>
      </g>
    </svg>
  </SvgIcon>
);

export const ApplicationRecordPageSvgIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 17.874 21.843"
      fill="currentColor"
      stroke="currentColor"
    >
      <g transform="translate(-27 -180)">
        <g transform="translate(0 0.571)">
          <g transform="translate(24 178.429)">
            <path
              d="M13.921,2H5.984A1.984,1.984,0,0,0,4,3.984V19.858a1.984,1.984,0,0,0,1.984,1.984H17.89a1.984,1.984,0,0,0,1.984-1.984V7.953Z"
              transform="translate(0 0)"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            />
            <path
              d="M14,2V7.953h5.953"
              transform="translate(-0.079 0)"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            />
          </g>
          <g transform="translate(-0.864)">
            <path
              d="M100.817-278.4l-.6.6-.182-.19c-.438-.45-.686-.537-.913-.31a.346.346,0,0,0-.12.3c0,.165.021.19.487.661.491.5.607.566.826.516a10.628,10.628,0,0,0,1.673-1.693.4.4,0,0,0-.4-.479C101.428-279,101.391-278.971,100.817-278.4Z"
              transform="translate(-67.636 470.482)"
              strokeWidth="0.2"
            />
            <path
              d="M100.813-202.393l-.615.6-.3-.293c-.326-.314-.458-.376-.648-.3a.409.409,0,0,0-.248.4c0,.14.041.194.508.661.5.5.512.508.69.508s.186,0,.942-.756a8.841,8.841,0,0,0,.814-.876.49.49,0,0,0,.033-.24.46.46,0,0,0-.413-.318C101.441-203,101.371-202.946,100.813-202.393Z"
              transform="translate(-67.636 397.62)"
              strokeWidth="0.2"
            />
          </g>
          <path
            d="M35.273,192.25H40.75"
            fill="none"
            strokeLinecap="round"
            strokeWidth="1"
          />
          <path
            d="M35.273,192.25H40.75"
            transform="translate(0 3.548)"
            fill="none"
            strokeLinecap="round"
            strokeWidth="1"
          />
        </g>
      </g>
    </svg>
  </SvgIcon>
);

export const ApplicationCustomizationSvgIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 22.854 21.842"
      fill="currentColor"
    >
      <defs>
        <clipPath>
          <rect transform="translate(0 0)" />
        </clipPath>
      </defs>
      <g transform="translate(0 0)">
        <g clipPath="url(#clip-path)">
          <path d="M16.874,7.953H10.921a1,1,0,0,1-1-1V1a1,1,0,0,1,2,0V5.953h4.953a1,1,0,0,1,0,2" />
          <path d="M15.874,18.109v.749a.984.984,0,0,1-.983.983H2.984A.984.984,0,0,1,2,18.858V2.984A.985.985,0,0,1,2.984,2h7.523l5.367,5.367,1.9-.831a.99.99,0,0,0-.194-.29L11.628.293A1,1,0,0,0,10.921,0H2.984A2.987,2.987,0,0,0,0,2.984V18.858a2.986,2.986,0,0,0,2.984,2.983H14.891a2.986,2.986,0,0,0,2.983-2.983V16.176Z" />
          <path d="M11.675,18.035a.75.75,0,0,1-.728-.931l.607-2.43a.743.743,0,0,1,.2-.349l7.585-7.586a2.039,2.039,0,0,1,2.965,2.8c-.01.011-.077.079-.088.089l-7.578,7.579a.759.759,0,0,1-.348.2l-2.43.608a.755.755,0,0,1-.182.022m1.284-2.8L12.7,16.254,13.721,16l7.445-7.446a.572.572,0,0,0,.187-.427.538.538,0,0,0-.932-.351l-.017.016Zm6.915-7.978h0Z" />
        </g>
      </g>
    </svg>
  </SvgIcon>
);

export const EnumOptionEnabledSvgIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 25 25"
      fill="#f3fef8"
      stroke="currentColor"
    >
      <g>
        <g>
          <g>
            <g strokeWidth="2.5">
              <circle cx="12.5" cy="12.5" r="12.5" stroke="none" />
              <circle cx="12.5" cy="12.5" r="11.25" fill="none" />
            </g>
          </g>
        </g>
      </g>
      <path
        d="M14.455,6,7.267,13.188,4,9.92"
        transform="translate(3.104 3.687)"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
    </svg>
  </SvgIcon>
);

export const EnumOptionHiddenSvgIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="#f9f9f9"
      stroke="currentColor"
      viewBox="0 0 25 25"
    >
      <g>
        <g>
          <g strokeWidth="2.5">
            <circle cx="12.5" cy="12.5" r="12.5" stroke="none" />
            <circle cx="12.5" cy="12.5" r="11.25" fill="none" />
          </g>
        </g>
      </g>
      <g transform="translate(5.525 10.153)">
        <path
          d="M33.7,96.482a.77.77,0,1,1-1.334.768l-1.08-1.889a8.144,8.144,0,0,1-1.932.887l.339,2.026a.768.768,0,0,1-.632.884.718.718,0,0,1-.128.011.768.768,0,0,1-.757-.64l-.33-1.972a8.74,8.74,0,0,1-1.925,0L25.6,98.531a.768.768,0,0,1-.758.64.718.718,0,0,1-.128-.011.768.768,0,0,1-.63-.886l.339-2.031a8.144,8.144,0,0,1-1.932-.887l-1.08,1.894a.77.77,0,1,1-1.334-.768l1.179-2.059a10.227,10.227,0,0,1-1.108-1.172.768.768,0,0,1,1.194-.966,6.916,6.916,0,0,0,11.1,0,.768.768,0,1,1,1.2.966,10.228,10.228,0,0,1-1.11,1.172Z"
          transform="translate(-19.974 -92)"
          fill="currentColor"
          strokeWidth="0"
        />
      </g>
    </svg>
  </SvgIcon>
);

export const EnumOptionDisabledSvgIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 25 25"
      fill="#fff6f2"
      stroke="currentColor"
    >
      <g>
        <g>
          <g strokeWidth="2.5">
            <circle cx="12.5" cy="12.5" r="12.5" stroke="none" />
            <circle cx="12.5" cy="12.5" r="11.25" fill="none" />
          </g>
        </g>
      </g>
      <g transform="translate(7.083 7.5)">
        <line y1="10" x2="10.833" fill="none" strokeWidth="2.5" />
      </g>
    </svg>
  </SvgIcon>
);

export const ApplicationGroupSvgIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg
      viewBox="0 0 24 25"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path d="M12.5 10.4998C12.5 8.84977 11.15 7.49977 9.5 7.49977C7.85 7.49977 6.5 8.84977 6.5 10.4998C6.5 12.1498 7.85 13.4998 9.5 13.4998C11.15 13.4998 12.5 12.1498 12.5 10.4998ZM9.5 11.4998C8.95 11.4998 8.5 11.0498 8.5 10.4998C8.5 9.94977 8.95 9.49977 9.5 9.49977C10.05 9.49977 10.5 9.94977 10.5 10.4998C10.5 11.0498 10.05 11.4998 9.5 11.4998ZM16 13.4998C17.11 13.4998 18 12.6098 18 11.4998C18 10.3898 17.11 9.49977 16 9.49977C14.89 9.49977 13.99 10.3898 14 11.4998C14 12.6098 14.89 13.4998 16 13.4998ZM11.99 2.50977C6.47 2.50977 1.99 6.98977 1.99 12.5098C1.99 18.0298 6.47 22.5098 11.99 22.5098C17.51 22.5098 21.99 18.0298 21.99 12.5098C21.99 6.98977 17.51 2.50977 11.99 2.50977ZM5.84 17.6198C6.52 17.0798 8.11 16.5098 9.5 16.5098C9.57 16.5098 9.65 16.5198 9.73 16.5198C9.97 15.8798 10.4 15.2298 11.03 14.6598C10.47 14.5598 9.94 14.4998 9.5 14.4998C8.2 14.4998 6.11 14.9498 4.77 15.9298C4.27 14.8898 3.99 13.7298 3.99 12.4998C3.99 8.08977 7.58 4.49977 11.99 4.49977C16.4 4.49977 19.99 8.08977 19.99 12.4998C19.99 13.6998 19.72 14.8398 19.24 15.8698C18.24 15.2798 16.88 14.9998 16 14.9998C14.48 14.9998 11.5 15.8098 11.5 17.6998V20.4798C9.23 20.3498 7.21 19.2698 5.84 17.6198Z" />
      </g>
      <defs>
        <rect transform="translate(0 0.5)" />
      </defs>
    </svg>
  </SvgIcon>
);

export const ItemSchemaSvgIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.1667 1.33333V7.33333H7.83333V10.6667H1.83333V1.33333H11.1667ZM11.1667 0H1.83333C1.1 0 0.5 0.6 0.5 1.33333V10.6667C0.5 11.4 1.1 12 1.83333 12H8.5L12.5 8V1.33333C12.5 0.6 11.9 0 11.1667 0ZM6.5 7.33333H3.16667V6H6.5V7.33333ZM9.83333 4.66667H3.16667V3.33333H9.83333V4.66667Z"
        fill="currentColor"
      />
    </svg>
  </SvgIcon>
);

export const PortalDisplaySchemaSvgIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_726_2203)">
        <path
          d="M10.6667 1.33333V7.33333H7.33333V10.6667H1.33333V1.33333H10.6667ZM10.6667 0H1.33333C0.6 0 0 0.6 0 1.33333V10.6667C0 11.4 0.6 12 1.33333 12H8L12 8V1.33333C12 0.6 11.4 0 10.6667 0ZM10.6667 6H1.33333V4.66667H10.6667V6Z"
          fill="currentColor"
        />
        <path
          d="M5.33333 1.33333V4.66667H6.66667V1.33333L5.33333 1.33333Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_726_2203">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </SvgIcon>
);

export const ApplicationAgentSvgIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_911_2191)">
        <path
          d="M13.9999 8.64667C13.9999 4.98667 11.1599 2.5 7.99992 2.5C4.87325 2.5 1.99992 4.93333 1.99992 8.68667C1.59992 8.91333 1.33325 9.34 1.33325 9.83333V11.1667C1.33325 11.9 1.93325 12.5 2.66659 12.5H3.33325V8.43333C3.33325 5.85333 5.41992 3.76667 7.99992 3.76667C10.5799 3.76667 12.6666 5.85333 12.6666 8.43333V13.1667H7.33325V14.5H12.6666C13.3999 14.5 13.9999 13.9 13.9999 13.1667V12.3533C14.3933 12.1467 14.6666 11.74 14.6666 11.26V9.72667C14.6666 9.26 14.3933 8.85333 13.9999 8.64667Z"
          fill="currentColor"
        />
        <path
          d="M5.99992 9.83333C6.36811 9.83333 6.66659 9.53486 6.66659 9.16667C6.66659 8.79848 6.36811 8.5 5.99992 8.5C5.63173 8.5 5.33325 8.79848 5.33325 9.16667C5.33325 9.53486 5.63173 9.83333 5.99992 9.83333Z"
          fill="currentColor"
        />
        <path
          d="M9.99992 9.83333C10.3681 9.83333 10.6666 9.53486 10.6666 9.16667C10.6666 8.79848 10.3681 8.5 9.99992 8.5C9.63173 8.5 9.33325 8.79848 9.33325 9.16667C9.33325 9.53486 9.63173 9.83333 9.99992 9.83333Z"
          fill="currentColor"
        />
        <path
          d="M11.9998 7.85333C11.6798 5.95333 10.0265 4.5 8.03315 4.5C6.01315 4.5 3.83982 6.17333 4.01315 8.8C5.65982 8.12667 6.89982 6.66 7.25315 4.87333C8.12648 6.62667 9.91982 7.83333 11.9998 7.85333Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_911_2191">
          <rect
            width="16"
            height="16"
            fill="currentColor"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  </SvgIcon>
);
